<template>
    <div class="articolo" style="padding: 20px">
        <!-- to visualize the pdf dialog -->
        <v-dialog content-class="artDialog" v-model="pdfdialog" width="unset">
            <GenericPDFReaderVue
                @closedialog="closepdf"
                :selectedPdf="this.selectedPdf"
            />
        </v-dialog>

        <!-- Returnig back with unsaved form will show this alert -->
        <v-dialog
            content-class="artDialog"
            persistent
            v-model="dialogAvvisoModificheNonSalvate"
            width="800"
        >
            <v-card>
                <v-toolbar dense class="indigo">
                    <v-toolbar-title class="white--text">
                        Modifiche Non Salvate
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text class="mt-6">
                    <h3>
                        Ci sono modifiche non salvate nell'articolo, vuoi
                        salvarle?
                    </h3>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green"
                        dark
                        @click="
                            dialogAvvisoModificheNonSalvate = false;
                            salvaArticolo(false);
                        "
                    >
                        Si
                    </v-btn>
                    <v-btn color="red" dark @click="GobacktoLista">No</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog to Add new File to Articolo -->
        <v-dialog
            content-class="artDialog"
            persistent
            v-model="dialogAggiungiAllegato"
            width="500"
        >
            <v-card>
                <v-toolbar dense class="indigo darken-1" primary-title>
                    <v-toolbar-title class="white--text">
                        Aggiungi Allegati all'Articolo
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-n4"
                                @click="dialogAggiungiAllegato = false"
                                small
                            >
                                <v-icon
                                    v-on="on"
                                    v-bind="attrs"
                                    depressed
                                    color="error"
                                >
                                    mdi-window-close
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Cancellare</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-file-input
                        accept="*"
                        @change="onFileChange(allegato)"
                        style="display: inline-block; width: 400px"
                        type="file"
                        v-model="allegato"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal When you search an Articolo inside a Articolo Detail -->
        <ArticoloSearchModal
            :key="dialog"
            :headers="this.header"
            v-on:closeModal="hideDetail"
            v-on:onDetail="onButtonClick($event)"
            v-on:modalSearch="searchResult1($event)"
            v-on:sendVal="sendVal($event)"
            :compdata="this.completeData.lista"
            :dialog="dialog"
            :tipoList="this.tipoList"
            :famigliaList="this.famiglia_list"
            :codArticolo="this.codArticolo"
        />
        <!-- Main Search Articolo Form on landing Page of Articolo -->
        <div class="hoverDiv" v-show="this.topDiv" :elevation="24">
            <v-card class="cercaArt">
                <v-toolbar color="indigo" dense primary-title>
                    <v-toolbar-title class="white--text">
                        Articolo <v-icon color="white">mdi-dolly</v-icon>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <Button
                        classe_bottone="mr-5"
                        colore_icona="primary"
                        idForm="ARTICOLO"
                        idOggetto="CREA_ARTICOLO"
                        mdi_icona="mdi-plus"
                        stile_icona=""
                        testo_tooltip="Nuovo Articolo"
                        v-on:buttonClick="showArticoloForm"
                    />

                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="mr-5"
                                @click="filtro_visible = true"
                                small
                                v-bind="attrs"
                                v-on="on"
                                ><v-icon color="primary"
                                    >mdi-filter</v-icon
                                ></v-btn
                            >
                        </template>
                        <span>Visualizza Filtri</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="resetFiltro"
                                small
                                v-bind="attrs"
                                v-on="on"
                                ><v-icon color="primary"
                                    >mdi-filter-off</v-icon
                                ></v-btn
                            >
                        </template>
                        <span>Resetta Filtro</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="mr-5"
                                @click="ClickAI"
                                small
                                v-bind="attrs"
                                v-on="on"
                                ><v-icon color="primary"
                                    >mdi-brain</v-icon
                                ></v-btn
                            >
                        </template>
                        <span>Ricerca con IA</span>
                    </v-tooltip>
                    <v-spacer />
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class=""
                                @click="gotoDashboard"
                                small
                            >
                                <v-icon color="error"
                                    >mdi-keyboard-backspace</v-icon
                                >
                            </v-btn>
                        </template>
                        <span>Vai alla Dashboard</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-subtitle>
                    <v-row>
                        <v-col class="py-0" cols="4" md="2">
                            <TextField
                                idForm="ARTICOLO"
                                idOggetto="CODICE_ARTICOLO"
                                label_input="Cod. Articolo"
                                :vmodel="cod_articolo"
                                :clearable_input="this.showicon ? true : false"
                                v-on:changeText="
                                    (val) => (
                                        (this.cod_articolo = val),
                                        changeHandler()
                                    )
                                "
                                v-on:keyEnter="searchArticolo"
                            />
                        </v-col>
                        <v-col class="py-0" cols="4" md="2">
                            <TextField
                                idForm="ARTICOLO"
                                idOggetto="DESCRIZIONE_ARTICOLO"
                                label_input="Des. Articolo"
                                :vmodel="des_articolo"
                                :clearable_input="this.showicon ? true : false"
                                v-on:changeText="
                                    (val) => (
                                        (this.des_articolo = val),
                                        changeHandler()
                                    )
                                "
                                v-on:keyEnter="searchArticolo"
                            />
                        </v-col>
                        <v-col class="py-0" cols="4" md="2">
                            <v-select
                                :items="[
                                    { text: 'Attivi', value: 1 },
                                    { text: 'Disattivati', value: 0 },
                                ]"
                                item-text="text"
                                item-value="value"
                                label="Stato"
                                v-model="validita_search"
                            ></v-select>
                        </v-col>
                        <v-col
                            class="py-0 d-flex justify-center"
                            cols="1"
                            md="1"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        class="mt-6"
                                        :disabled="disabled"
                                        @click="searchArticolo"
                                        small
                                    >
                                        <v-icon
                                            v-on="on"
                                            class
                                            v-bind="attrs"
                                            size="32"
                                            color="#1a80b6"
                                            >mdi-magnify</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Cerca Articolo</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-row
                        class="mb-2"
                        align="center"
                        justify="center"
                        v-if="filtro_visible"
                    >
                        <v-col cols="4" md="2">
                            <v-autocomplete
                                background-color="#ffffff"
                                @change="(sub_tipo_search = ''), filtra()"
                                dense
                                hide-details
                                :items="actualItems_backup"
                                item-text="id_tipo"
                                item-value="id_tipo_R"
                                label="Tipo"
                                style="display: inline-block; max-width: 350px"
                                v-model="tipo_search"
                            >
                                <template v-slot:append>
                                    <v-icon
                                        class="ml-2"
                                        @click="
                                            tipo_search = '';
                                            filtra();
                                        "
                                        color="primary"
                                        >{{
                                            tipo_search == ""
                                                ? "mdi-filter"
                                                : "mdi-filter-off"
                                        }}</v-icon
                                    >
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="4" md="2">
                            <v-autocomplete
                                background-color="#ffffff"
                                @change="(sub_famiglia_search = ''), filtra()"
                                dense
                                hide-details
                                :items="actualItems_backup"
                                item-text="id_famiglia"
                                item-value="id_famiglia_R"
                                label="Famiglia"
                                style="display: inline-block; max-width: 350px"
                                v-model="famiglia_search"
                            >
                                <template v-slot:append>
                                    <v-icon
                                        class="ml-2"
                                        @click="
                                            famiglia_search = '';
                                            filtra();
                                        "
                                        color="primary"
                                        >{{
                                            famiglia_search == ""
                                                ? "mdi-filter"
                                                : "mdi-filter-off"
                                        }}</v-icon
                                    >
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="4" md="2">
                            <v-autocomplete
                                background-color="#ffffff"
                                @change="filtra"
                                dense
                                hide-details
                                :items="actualItems_backup"
                                item-text="id_tipo_fornitura"
                                item-value="id_tipo_fornitura"
                                label="Fornitura"
                                style="display: inline-block; max-width: 350px"
                                v-model="fornitura_search"
                            >
                                <template v-slot:append>
                                    <v-icon
                                        class="ml-2"
                                        @click="
                                            fornitura_search = '';
                                            filtra();
                                        "
                                        color="primary"
                                        >{{
                                            fornitura_search == ""
                                                ? "mdi-filter"
                                                : "mdi-filter-off"
                                        }}
                                    </v-icon>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="4" md="2">
                            <v-autocomplete
                                background-color="#ffffff"
                                @change="filtra"
                                dense
                                hide-details
                                :items="
                                    actualItems_backup.filter(
                                        (f) => f.val_int_sub_tipo == tipo_search
                                    )
                                "
                                item-text="des_sub_tipo"
                                item-value="id_sub_tipo"
                                label="Sub Tipo"
                                style="display: inline-block; max-width: 350px"
                                v-model="sub_tipo_search"
                            >
                                <template v-slot:append>
                                    <v-icon
                                        class="ml-2"
                                        @click="
                                            sub_tipo_search = '';
                                            filtra();
                                        "
                                        color="primary"
                                        >{{
                                            sub_tipo_search == ""
                                                ? "mdi-filter"
                                                : "mdi-filter-off"
                                        }}</v-icon
                                    >
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="4" md="2">
                            <v-autocomplete
                                background-color="#ffffff"
                                @change="filtra"
                                dense
                                hide-details
                                :items="
                                    actualItems_backup.filter(
                                        (f) =>
                                            f.val_int_sub_famiglia ==
                                            famiglia_search
                                    )
                                "
                                item-text="des_sub_famiglia"
                                item-value="id_sub_famiglia"
                                label="Sub famiglia"
                                style="display: inline-block; max-width: 350px"
                                v-model="sub_famiglia_search"
                            >
                                <template v-slot:append>
                                    <v-icon
                                        class="ml-2"
                                        @click="
                                            sub_famiglia_search = '';
                                            filtra();
                                        "
                                        color="primary"
                                        >{{
                                            sub_famiglia_search == ""
                                                ? "mdi-filter"
                                                : "mdi-filter-off"
                                        }}</v-icon
                                    >
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card-subtitle>
                <v-card-text class="mt-n4">
                    <v-data-table
                        :loading="loadingVal"
                        :headers="headers2"
                        :items="items"
                        fixed-header
                        height="60vh"
                    >
                        <v-progress-linear
                            v-show="progressBar"
                            slot="progress"
                            color="blue"
                            indeterminate
                        ></v-progress-linear>
                        <!-- Colonna per l'azione di analisi -->
                        <template v-slot:[`item.analisi`]="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        v-on="on"
                                        small
                                        @click="analisiArticolo(item)"
                                    >
                                        <v-icon color="primary"
                                            >mdi-abacus</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Analisi</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:[`item.detail`]="{ item }">
                            <Button
                                classe_bottone="mr-5"
                                colore_icona="primary"
                                idForm="ARTICOLO"
                                idOggetto="MODIFICA_ARTICOLO"
                                mdi_icona="mdi-pencil"
                                testo_tooltip="Dettaglio Articolo"
                                v-on:buttonClick="onButtonClick(item)"
                            />
                        </template>
                        <template v-slot:[`item.delete`]="{ item }">
                            <Button
                                classe_bottone="mr-5"
                                colore_icona="error"
                                idForm="ARTICOLO"
                                idOggetto="ELIMINA_ARTICOLO"
                                mdi_icona="mdi-window-close"
                                stile_icona="float: left"
                                testo_tooltip="Rimuovere Articolo"
                                v-on:buttonClick="
                                    confermaDelArticolo = true;
                                    selectedArticolo = item;
                                "
                            />
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </div>
        <!-- Menu per la main dashboard dell'articolo dopo la selezione -->
        <div v-if="!this.topDiv">
            <v-card>
                <v-toolbar
                    primary-title
                    dense
                    v-if="this.disableAppBar"
                    class="indigo darken-1 headline"
                >
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-on="on"
                                v-bind="attrs"
                                class="mr-5"
                                small
                                v-show="showadd"
                                @click="hideIcons"
                            >
                                <v-icon style="color: #1a80b6">mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>Per Aggiungere Un Nuovo Articolo</span>
                    </v-tooltip>
                    <!-- Bottone di aggiornamento -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-on="on"
                                v-bind="attrs"
                                class="mr-5"
                                small
                                v-show="showupdate"
                                @click="hideIconS"
                            >
                                <v-icon color="#1a80b6">mdi-replay</v-icon>
                            </v-btn>
                        </template>
                        <span>Vai all'Aggiornamento dell'Articolo</span>
                    </v-tooltip>

                    <!-- Bottone del salvataggio secco -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="salvaArticolo(false)"
                                class="mr-5"
                                small
                                v-bind="attrs"
                                v-show="savebutton"
                                v-on="on"
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva Articolo</span>
                    </v-tooltip>

                    <!-- Bottone del salvataggio secco -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="mr-5"
                                @click="salvaArticolo(true)"
                                small
                                v-bind="attrs"
                                v-if="savebutton"
                                v-on="on"
                            >
                                <v-icon color="success">
                                    mdi-content-save-move
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva e Continua</span>
                    </v-tooltip>
                    <Button
                        v-if="articolo_sel.id_articolo > -1"
                        classe_bottone="mr-5"
                        colore_icona="primary"
                        idForm="ARTICOLO"
                        idOggetto="DUPLICA_ARTICOLO"
                        mdi_icona="mdi-content-copy"
                        testo_tooltip="Duplica Articolo"
                        v-on:buttonClick="clickDuplicaArticolo"
                    />

                    <Button
                        v-if="articolo_sel.id_articolo > -1"
                        classe_bottone="mr-5"
                        colore_icona="primary"
                        idForm="ARTICOLO"
                        idOggetto="GESTIONE_ALLEGATI"
                        mdi_icona="mdi-paperclip"
                        testo_tooltip="Allegati Articolo"
                        v-on:buttonClick="clickGestioneAllegati"
                    />
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-on="on"
                                v-bind="attrs"
                                @click="GoBack"
                                small
                            >
                                <v-icon color="red"
                                    >mdi-keyboard-backspace</v-icon
                                >
                            </v-btn>
                        </template>
                        <span>Indietro</span>
                    </v-tooltip>
                </v-toolbar>

                <v-form action>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12" md="10" class="py-0">
                                <v-container fluid>
                                    <v-row align="center" justify="center">
                                        <v-col class="pb-0" cols="4" md="3">
                                            <TextField
                                                dense_input
                                                :readonly="
                                                    cod_articolo_alteration
                                                "
                                                idForm="ARTICOLO"
                                                idOggetto="CODICE_ARTICOLO"
                                                label_input="Cod. Articolo"
                                                palceholder_input="Inserisci il Codice"
                                                :vmodel="
                                                    articolo_sel.cod_articolo
                                                "
                                                v-on:changeText="
                                                    (val) =>
                                                        (articolo_sel.cod_articolo =
                                                            val)
                                                "
                                                v-on:keyEnter="searchResult"
                                            />
                                        </v-col>
                                        <v-col class="pb-0" cols="1">
                                            <v-icon
                                                v-if="showicon"
                                                class="mt-6"
                                                @click="searchResult"
                                                color="#1a80b6"
                                                size="24"
                                                >mdi-magnify</v-icon
                                            >
                                        </v-col>
                                        <v-col class="pb-0" cols="7" md="5">
                                            <TextField
                                                dense_input
                                                :readonly="disabledes"
                                                idForm="ARTICOLO"
                                                idOggetto="DES_ARTICOLO"
                                                label_input="Descrizione"
                                                palceholder_input="Inserisci il Descrizione"
                                                :vmodel="
                                                    articolo_sel.des_articolo
                                                "
                                                v-on:changeText="
                                                    (val) =>
                                                        (articolo_sel.des_articolo =
                                                            val)
                                                "
                                            />
                                        </v-col>
                                        <!-- :items="articolo_fake_list" -->
                                        <v-col class="pb-0" cols="6" md="3">
                                            <v-autocomplete
                                                dense
                                                v-model="articolo_sel.id_tipo"
                                                :items="tipoList"
                                                :disabled="disabletipo"
                                                label="Tipo Articolo"
                                                placeholder="Tipo Articolo"
                                                item-text="des"
                                                item-value="id_tabella"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col class="py-0" cols="6" md="4">
                                            <v-autocomplete
                                                dense
                                                v-model="
                                                    articolo_sel.id_sub_tipo
                                                "
                                                :items="
                                                    subtipoList.filter(
                                                        (el) =>
                                                            el.val_int ===
                                                            articolo_sel.id_tipo
                                                    )
                                                "
                                                label="Sub Tipo Articolo"
                                                placeholder="Sub Tipo Articolo"
                                                item-text="des"
                                                required
                                                item-value="id_tabella"
                                            >
                                                <template #label>
                                                    <span class=""
                                                        >Sub Tipo Art.<strong
                                                            >*
                                                        </strong></span
                                                    >
                                                    <span
                                                        @click.stop
                                                        style="
                                                            min-width: 500px;
                                                            pointer-events: all;
                                                        "
                                                    >
                                                        <Modules
                                                            v-on:dialogModules="
                                                                aggiornaSubTipoArticolo
                                                            "
                                                            tipo="SUB_TIPO_ARTICOLO"
                                                            nome="Sub-tipo Articolo"
                                                            setaction="settabelle"
                                                            getaction="gettabelle"
                                                            controller="Magazzino"
                                                            :filter="
                                                                '(val_int = ' +
                                                                articolo_sel.id_tipo +
                                                                ') AND validita = 1'
                                                            "
                                                            :dati="[
                                                                { des: '' },
                                                                {
                                                                    val_int:
                                                                        articolo_sel.id_tipo,
                                                                },
                                                            ]"
                                                        />
                                                    </span>
                                                </template>
                                                <template v-slot:append>
                                                    <v-icon
                                                        v-if="
                                                            articolo_sel.id_sub_tipo !=
                                                                null &&
                                                            articolo_sel.id_sub_tipo !=
                                                                '' &&
                                                            articolo_sel.id_sub_tipo !=
                                                                undefined
                                                        "
                                                        color="red"
                                                        @click="
                                                            articolo_sel.id_sub_tipo =
                                                                null
                                                        "
                                                        >mdi-delete</v-icon
                                                    >
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col class="py-0" cols="6" md="4">
                                            <v-autocomplete
                                                dense
                                                v-model="
                                                    articolo_sel.id_famiglia
                                                "
                                                :items="famiglia_list"
                                                item-text="des"
                                                :disabled="disableFam"
                                                required
                                                item-value="id_tabella"
                                                class="input-group--focused"
                                                placeholder="Tipo Famiglia"
                                                label="Tipo Famiglia"
                                            >
                                                <template #label>
                                                    <span class=""
                                                        >Famiglia<strong
                                                            >*
                                                        </strong></span
                                                    >
                                                    <a
                                                        @click.stop
                                                        style="
                                                            pointer-events: all;
                                                        "
                                                    >
                                                        <Modules
                                                            v-on:dialogModules="
                                                                aggiornaFamiglia
                                                            "
                                                            tipo="Famiglia"
                                                            nome="Famiglia"
                                                            setaction="settabelle"
                                                            getaction="gettabelle"
                                                            controller="Magazzino"
                                                            filter="validita = 1"
                                                            :dati="[
                                                                { des: '' },
                                                            ]"
                                                        />
                                                    </a>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col class="py-0" cols="6" md="4">
                                            <v-autocomplete
                                                dense
                                                v-model="
                                                    articolo_sel.id_sub_famiglia
                                                "
                                                :items="
                                                    sottoFamList.filter(
                                                        (el) =>
                                                            el.val_int ===
                                                            articolo_sel.id_famiglia
                                                    )
                                                "
                                                label="Sub Fam."
                                                placeholder="Sub Fam."
                                                item-text="des"
                                                required
                                                item-value="id_tabella"
                                                :key="key_sub_famiglia"
                                            >
                                                <template #label>
                                                    <span class="">
                                                        Sub Famiglia Art.<strong
                                                            >*
                                                        </strong>
                                                    </span>
                                                    <span
                                                        @click.stop
                                                        style="
                                                            min-width: 500px;
                                                            pointer-events: all;
                                                        "
                                                    >
                                                        <Modules
                                                            v-on:dialogModules="
                                                                aggiornaSottoFamiglia
                                                            "
                                                            tipo="SOTTO_FAMIGLIA"
                                                            nome="Sotto-Famiglia"
                                                            setaction="settabelle"
                                                            getaction="gettabelle"
                                                            controller="Magazzino"
                                                            :filter="
                                                                articolo_sel.id_famiglia ==
                                                                null
                                                                    ? `(val_int IS NULL) AND validita = 1`
                                                                    : `(val_int = ${articolo_sel.id_famiglia}) AND validita = 1`
                                                            "
                                                            :dati="[
                                                                { des: '' },
                                                                { cod: '' },
                                                                {
                                                                    val_int:
                                                                        articolo_sel.id_famiglia,
                                                                },
                                                            ]"
                                                        />
                                                    </span>
                                                </template>
                                                <template v-slot:append>
                                                    <v-icon
                                                        v-if="
                                                            articolo_sel.id_sub_famiglia !=
                                                                null &&
                                                            articolo_sel.id_sub_famiglia !=
                                                                undefined &&
                                                            articolo_sel.id_sub_famiglia !=
                                                                ''
                                                        "
                                                        color="red"
                                                        @click="
                                                            articolo_sel.id_sub_famiglia =
                                                                null
                                                        "
                                                        >mdi-delete</v-icon
                                                    >
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col class="pt-0" cols="3">
                                            <v-autocomplete
                                                dense
                                                v-model="
                                                    articolo_sel.id_tipo_fornitura
                                                "
                                                :items="fornitura_list"
                                                item-text="des"
                                                :disabled="disableForn"
                                                required
                                                item-value="id_tabella"
                                                placeholder="Tipo Fornitura"
                                                label="Tipo Fornitura"
                                            >
                                                <template #label>
                                                    <span class=""
                                                        >Fornitura<strong
                                                            >*
                                                        </strong></span
                                                    >
                                                    <a
                                                        @click.stop
                                                        style="
                                                            pointer-events: all;
                                                        "
                                                    >
                                                        <v-icon
                                                            @click="apriModules"
                                                            color="primary"
                                                        >
                                                            mdi-eye
                                                        </v-icon>
                                                    </a>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col class="pt-0" cols="7" md="3">
                                            <TextField
                                                dense_input
                                                :readonly="disableAggun"
                                                idForm="ARTICOLO"
                                                idOggetto="DES_AGGIUNTIVA"
                                                label_input="Descrizione Aggiuntiva"
                                                palceholder_input="Inserisci la Des. Aggiuntiva"
                                                :vmodel="
                                                    articolo_sel.des_aggiuntiva
                                                "
                                                v-on:changeText="
                                                    (val) =>
                                                        (articolo_sel.des_aggiuntiva =
                                                            val)
                                                "
                                            />
                                        </v-col>
                                        <v-col class="pt-0" cols="2">
                                            Col. Testo Sched.
                                            <v-btn
                                                @click="modificaColore(1)"
                                                :color="
                                                    colore_testo == null
                                                        ? '#000000'
                                                        : colore_testo
                                                "
                                                small
                                            >
                                                <v-icon color="white">
                                                    {{
                                                        colore_testo == null
                                                            ? "mdi-help"
                                                            : ""
                                                    }}
                                                </v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col class="pt-0" cols="2">
                                            Col. Sfondo Sched.
                                            <v-btn
                                                @click="modificaColore(2)"
                                                :color="
                                                    colore_sfondo == null
                                                        ? '#000000'
                                                        : colore_sfondo
                                                "
                                                small
                                            >
                                                <v-icon color="white">
                                                    {{
                                                        colore_sfondo == null
                                                            ? "mdi-help"
                                                            : ""
                                                    }}
                                                </v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col class="pt-0" cols="2">
                                            <v-autocomplete
                                                dense
                                                v-model="
                                                    articolo_sel.id_centro_costo
                                                "
                                                :items="centroCostoList"
                                                label="Centro di Costo"
                                                placeholder="Centro di Costo"
                                                item-text="des"
                                                required
                                                item-value="id_tabella"
                                                :key="key_centro_costo"
                                            >
                                                <template #label>
                                                    <span class="">
                                                        Centro Costo
                                                    </span>
                                                    <span
                                                        @click.stop
                                                        style="
                                                            min-width: 500px;
                                                            pointer-events: all;
                                                        "
                                                    >
                                                        <Modules
                                                            v-on:dialogModules="
                                                                aggiornaCentroCosto
                                                            "
                                                            tipo="CENTRO_COSTO"
                                                            nome="Centro-Costo"
                                                            setaction="settabelle"
                                                            getaction="gettabelle"
                                                            controller="Magazzino"
                                                            filter="validita = 1"
                                                            :dati="[
                                                                { des: '' },
                                                                { cod: '' },
                                                            ]"
                                                        />
                                                    </span>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-container>
                                    <v-row class="justify-center">
                                        <v-col class="pt-0" cols="12">
                                            <v-tooltip top>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-btn
                                                        small
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="
                                                            dialogAggiungiAllegato = true
                                                        "
                                                    >
                                                        <v-icon color="#1a80b6"
                                                            >mdi-image</v-icon
                                                        >
                                                    </v-btn>
                                                </template>

                                                <span
                                                    >Nuova Immagine
                                                    dell'Articolo</span
                                                >
                                            </v-tooltip>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            class="d-flex justify-center"
                                        >
                                            <div
                                                v-if="
                                                    !isPdf(
                                                        this.articolo_sel
                                                            .immagine_preview
                                                    )
                                                "
                                            >
                                                <img
                                                    id="immagine"
                                                    style="
                                                        height: 100% !important;
                                                        width: 100%;
                                                        display: block !important;
                                                    "
                                                    @click="showImageViewer"
                                                    :src="immagine_preview"
                                                    :lazy-src="immagine_preview"
                                                    aspect-ratio="1"
                                                    class="grey lighten-2"
                                                />
                                            </div>
                                            <v-card
                                                @click="openPdfAppenaCaricato"
                                                style="
                                                    height: 40px !important;
                                                    width: 80px !important;
                                                "
                                                v-if="
                                                    isPdf(this.immagine_preview)
                                                "
                                            >
                                                <div style="text-align: center">
                                                    <v-spacer></v-spacer>
                                                    <v-icon
                                                        color="error"
                                                        x-large
                                                    >
                                                        mdi-file-pdf-box
                                                    </v-icon>
                                                </div>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card>
            <v-divider class=""></v-divider>
            <!-- Tabs Drawer in order To Show the Sub components of Articolo  -->
            <ArticoloDrawer
                v-on:valChanged="disabled_Codice($event)"
                v-on:updateDrawer="updateArticle($event)"
                v-on:updatePackging="updatePackging($event)"
                :contentConte="this.content_cod_articolo"
                :imballoCod="this.imballo_cod_articolo"
                :data="this.articolo_sel"
                :key="this.articolo_sel.id_articolo"
                :CodEnable="this.cod_articolo_enable"
                ref="RefArticoloDrawer"
                @update_id_report="handleUpdateIdReport"
                @update_scadenza="handleUpdateScadenza"
                @update_um_scadenza="handleUpdateUMScadenza"
                @update_cod_prefisso_lotto="handleUpdateCodPrefissoLotto"
                @update_barcode="handleUpdateBarcode"
                @update_prefisso_lotto="handleUpdatePrefissoLotto"
                @update_prelievo_lotti_successivi="
                    handleUpdatePrelievoLottiSuccessivi
                "
            />
        </div>
        <!-- Confirmation Dialog For deletion of an articolo -->
        <v-dialog persistent v-model="confermaDelArticolo" width="unset">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                        Cancellazione</v-toolbar-title
                    >
                </v-toolbar>
                <v-card-text class="mt-10">
                    <h3>Vuoi veramente cancellare questo articolo?</h3>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <Button
                        colore_bottone="error"
                        idForm="ARTICOLO"
                        idOggetto="NON_CONFERMA_ELIMINA_ARTICOLO"
                        mdi_icona=""
                        testo_bottone="Annulla"
                        testo_tooltip="Annulla"
                        v-on:buttonClick="confermaDelArticolo = false"
                    />
                    <Button
                        colore_bottone="success"
                        idForm="ARTICOLO"
                        idOggetto="CONFERMA_ELIMINA_ARTICOLO"
                        :dark_bottone="true"
                        mdi_icona=""
                        testo_bottone="Conferma"
                        testo_tooltip="Conferma"
                        v-on:buttonClick="
                            deleteArticolo(selectedArticolo);
                            confermaDelArticolo = false;
                        "
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog di conferma duplicazione articolo -->
        <v-dialog v-model="conferma_duplica_dialog" width="unset">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                        Conferma Duplicazione
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="
                                    duplicaArticolo();
                                    conferma_duplica_dialog = false;
                                "
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="success">mdi-floppy</v-icon>
                            </v-btn>
                        </template>
                        <span>Duplica</span>
                    </v-tooltip>

                    <v-spacer></v-spacer>

                    <!-- Bottone di annullamento -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="
                                    conferma_duplica_dialog = false;
                                    cod_articolo_duplicazione = '';
                                    des_articolo_duplicazione = '';
                                    des_aggiuntiva_duplicazione = '';
                                "
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error"
                                    >mdi-keyboard-backspace</v-icon
                                >
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text class="mt-5" style="overflow-y: auto">
                    <span style="font-size: 18px">
                        Per confermare la duplicazione, inserire il Codice e/o
                        la Descrizione del nuovo articolo da creare.
                    </span>
                    <v-container>
                        <v-row align="center" justify="center">
                            <v-col
                                class="align-center d-flex justify-end"
                                cols="4"
                            >
                                <v-text-field
                                    class="mr-5"
                                    hide-details
                                    label="Cod. Articolo"
                                    style="max-width: 200px"
                                    v-model="cod_articolo_duplicazione"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                class="align-center d-flex justify-start"
                                cols="4"
                            >
                                <v-text-field
                                    class="ml-5"
                                    hide-details
                                    label="Des. Articolo"
                                    style="max-width: 200px"
                                    v-model="des_articolo_duplicazione"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                class="align-center d-flex justify-start"
                                cols="4"
                            >
                                <v-text-field
                                    class="ml-5"
                                    hide-details
                                    label="Descrizione Aggiuntiva"
                                    style="max-width: 200px"
                                    v-model="des_aggiuntiva_duplicazione"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="reportDialog" width="50vw">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                        Selezione Report
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="reportDialog = false"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-data-table :items="reports" :headers="reportHeaders">
                        <template v-slot:[`item.select`]="{ item }">
                            <v-btn small @click="selectReport(item)">
                                <v-icon color="success">mdi-check</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Finestra di dialogo per gli allegati nuovi -->
        <v-dialog
            class="ma-0 pa-0"
            v-model="gestione_allegati_visible"
            width="90vw"
        >
            <v-card
                class="ma-0 pa-0"
                height="calc(100vh - 100px)"
                style="overflow: hidden"
            >
                <div style="position: relative; height: 100%">
                    <WindowFrame
                        class="ma-0 pa-0"
                        referrerpolicy="origin"
                        @click_chiudi="gestione_allegati_visible = false"
                        :component="'allegati'"
                        ref="windowframe_allegati"
                        :input_args="input_args_allegati"
                        :key="allegatoKey"
                    />
                </div>
            </v-card>
        </v-dialog>

        <!-- Dialog degli allegati -->
        <!--<v-dialog v-model="gestione_allegati_visible">
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text">
          Gestione Allegati
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="showReportDialog" small v-bind="attrs" v-on="on">
              <v-icon color="primary">mdi-printer</v-icon>
            </v-btn>
          </template>
          <span>Stampa e allega</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="gestione_allegati_visible = false"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <GestioneAllegato
        :key="allegatoKey"
        @click_chiudi="gestione_allegati_visible = false"
        controller_allegati="Global"
        controller_caratteristiche_tabella="Manutenzione"
        :id_riferimento="articolo_sel.id_articolo"
        :read_only="false"
        ref="componenteAllegati"
        @salva_allegati="salvaAllegati"
        :show_save_button="true"
        @snackbarOpen="snackbarOpen"
        tipo_allegato="ALLEGATI_ARTICOLO"
      />
    </v-dialog>-->

        <!-- Dialog di scelta dei colori -->
        <v-dialog v-model="dialog_colori_visible" width="500px">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                        Colore {{ colore_sel === 1 ? "Testo" : "Sfondo" }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="salvaModificaColore"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="chiudiModificaColore"
                                small
                                v-bind="attrs"
                                v-on="on"
                                ><v-icon color="error">mdi-close</v-icon></v-btn
                            >
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text style="overflow-y: auto">
                    <v-container>
                        <v-row
                            align="center"
                            justify="center"
                            v-if="colore_sel === 1"
                        >
                            <v-col cols="12">
                                <v-color-picker
                                    class="ma-2"
                                    :swatches="swatches"
                                    show-swatches
                                    v-model="colore_testo_tmp"
                                ></v-color-picker>
                            </v-col>
                        </v-row>
                        <v-row align="center" justify="center" v-else>
                            <v-col cols="12">
                                <v-color-picker
                                    class="ma-2"
                                    :swatches="swatches"
                                    show-swatches
                                    v-model="colore_sfondo_tmp"
                                ></v-color-picker>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- Dialog analisi -->
        <v-dialog v-model="dialog_analisi_articolo">
            <v-card
                class="ma-0 pa-0"
                height="calc(100vh - 100px)"
                style="overflow: hidden"
            >
                <div style="position: relative; height: 100%">
                    <WindowFrame
                        class="ma-0 pa-0"
                        :component="'analisigenerale'"
                        :input_args="input_args"
                        :key="key_analisi_generale"
                        @click_chiudi="handleClickChiudiAnalisi"
                    />
                </div>
            </v-card>
        </v-dialog>

        <!-- Window Frame dei Modules -->
        <v-dialog v-model="dialog_modules" max-width="800" min-width="800">
            <v-card
                class="ma-0 pa-0"
                height="calc(100vh - 100px)"
                style="overflow: hidden"
            >
                <div
                    style="position: relative; height: 100%; overflow-y: hidden"
                >
                    <WindowFrame
                        class="ma-0 pa-0"
                        :component="'fwk'"
                        ref="windowframe_modules"
                        @chiudi="chiudiModules"
                        :input_args="input_args_modules"
                        :key="key_modules"
                    />
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="aiDialog" width="75vw">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text"
                        >Ricerca IA</v-toolbar-title
                    >
                    <v-spacer />
                    <v-btn @click="DoAISearch" small>
                        <v-icon color="primary">mdi-magnify</v-icon>
                    </v-btn>
                    <v-spacer />
                    <v-btn @click="aiDialog = false" small>
                        <v-icon color="error">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-col cols="12">
                        <v-row dense>
                            <v-col cols="12">
                                <v-textarea dense outlined v-model="aiPrompt" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-data-table
                                    :headers="aiHeaders"
                                    :items="aiResult"
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />

        <!-- TO show loader in Loading state -->
        <v-overlay :value="overlay" style="z-index: 9999999999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
// import _ from "lodash";
import ArticoloDrawer from "./ArticoloDrawer/ArticoloDrawer.vue";
import ArticoloSearchModal from "./ArticoloSearchModal";
import axios from "axios";
import Button from "../../../components/TOOLS/FormComponentPermissions/Button.vue";
import moment from "moment/moment";
//import GestioneAllegato from "@/components/TOOLS/GestioneAllegato.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import TextField from "../../../components/TOOLS/FormComponentPermissions/TextField.vue";
import GenericPDFReaderVue from "../../../components/TOOLS/GenericPDFReader.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
//import GestioneAllegato from "../../../../node_modules/gestione-allegato-libreria/src/components/GestioneAllegato.vue";

class Articolo {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] =
                    arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }
    // Metodo per resettare tutte le campi
    reset() {
        const campi = this.setCampi();

        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            { nome: "barcode", default_val: null },
            { nome: "cod_articolo", default_val: null },
            { nome: "costo_standard", default_val: null },
            { nome: "costo_imballo", default_val: null },
            { nome: "costo_trasporto", default_val: null },
            { nome: "des_aggiuntiva", default_val: "" },
            { nome: "des_articolo", default_val: null },
            { nome: "gestione_lotto", default_val: 0 },
            { nome: "gestione_seriale", default_val: 0 },
            { nome: "famiglia_articolo", default_val: "" },
            { nome: "fornitura_articolo", default_val: "" },
            { nome: "h", default_val: 0 },
            { nome: "id_articolo", default_val: -1 },
            { nome: "id_articolo_contenitore_standard", default_val: null },
            { nome: "id_centro_costo", default_val: null },
            { nome: "id_colore", default_val: null },
            { nome: "id_colore", default_val: null },
            { nome: "id_famiglia", default_val: null },
            { nome: "id_materiale", default_val: null },
            { nome: "cod_prefisso_lotto", default_val: null },
            { nome: "id_um", default_val: null },
            { nome: "id_um_fisica", default_val: null },
            { nome: "id_um_peso", default_val: null },
            { nome: "id_um_scadenza", default_val: null },
            { nome: "id_um_volume", default_val: null },
            { nome: "immagine_preview", default_val: "" },
            { nome: "id_report", default_val: null },
            { nome: "id_sub_famiglia", default_val: null },
            { nome: "id_sub_tipo", default_val: null },
            { nome: "id_taglia", default_val: null },
            { nome: "id_tipo", default_val: null },
            { nome: "id_tipo_fornitura", default_val: null },
            { nome: "l", default_val: 0 },
            { nome: "note", default_val: "" },
            { nome: "p", default_val: 0 },
            { nome: "peso_netto", default_val: 0 },
            { nome: "peso_lordo", default_val: 0 },
            { nome: "peso_specifico", default_val: 0 },
            { nome: "prefisso_lotto", default_val: 0 },
            { nome: "prelievo_lotti_successivi", default_val: 0 },
            { nome: "prezzo_standard", default_val: null },
            { nome: "qta_contenitore_standard", default_val: 0 },
            { nome: "qta_imballo_standard", default_val: 0 },
            { nome: "ricezione_peso_netto", default_val: 0 },
            { nome: "ricezione_peso_lordo", default_val: 0 },
            { nome: "scadenza", default_val: null },
            { nome: "tipo_articolo", default_val: "" },
            { nome: "tipo_costo", default_val: null },
            { nome: "validita", default_val: 1 },
            { nome: "vendita_kit", default_val: false },
            { nome: "volume", default_val: 0 },
            { nome: "diametro", default_val: "" },
        ];

        return campi;
    }
}

export default {
    name: "Articolo",
    // Child Components of Articolo Component
    components: {
        ArticoloDrawer,
        ArticoloSearchModal,
        Button,
        //GestioneAllegato,
        Modules: () => import("../../../components/TOOLS/Modules"),
        SnackbarQV,
        TextField,
        GenericPDFReaderVue,
        WindowFrame,
    },
    // ArticoloId if it is called in distinta base for detail of component
    props: {
        articoloId: { type: Number, default: null },
        back_as_landing_page: { type: Boolean, default: true },
        rotta_back: { type: String, default: "/home/production" },
    },
    data() {
        return {
            // Variabili d'appoggio
            aiPrompt: "",
            aiHeaders: [
                {
                    text: "Cod. Articolo",
                    value: "cod_articolo",
                },
                {
                    text: "Des. articolo",
                    value: "des_articolo",
                },
                {
                    text: "Tipo",
                    value: "id_tipo",
                },
                {
                    text: "Sub Tipo",
                    value: "id_sub_tipo",
                },
                {
                    text: "Famiglia",
                    value: "id_famiglia",
                },
                {
                    text: "Sub famiglia",
                    value: "id_sub_famiglia",
                },
                {
                    text: "Fornitura",
                    value: "id_tipo_fornitura",
                },
            ],
            aiResult: [],
            allegatoKey: false,
            articoloDetail: {},
            articolo_sel: new Articolo(),
            codArticolo: "",
            cod_articolo: "",
            cod_articolo_alteration: false,
            cod_articolo_duplicazione: "",
            cod_articolo_enable: false,
            colore_sel: 1,
            colore_sfondo: null,
            colore_sfondo_tmp: new Object(),
            colore_testo: null,
            colore_testo_tmp: new Object(),
            content_cod_articolo: "",
            des: "",
            des_aggiuntiva: "",
            des_aggiuntiva_duplicazione: "",
            des_articolo: "",
            des_articolo_duplicazione: "",
            disableAppBar: true,
            famiglia_articolo: "",
            famiglia_search: "",
            fornitura_search: "",
            hideField: true,
            id_articolo: "",
            id_famiglia: "",
            id_famiglia1: -1,
            id_sub_tipo: null,
            id_tipo: "",
            id_tipo1: -1,
            id_tipo_fornitura: "",
            image_for_viewer: "",
            image_for_viewer_extension: "",
            image_for_viewer_name: "",
            imballo_cod_articolo: "",
            immagine_preview: "",
            input_args: {},
            input_args_allegati: {
                cod_riferimento: "articolo",
                id_riferimento: -1,
                pk_riferimento: "id_articolo",
                id_utente: localStorage.id,
            },
            input_args_modules: {
                tipo: "FORNITURA_STANDARD",
                showScadenza: false,
                nome: "Fornitura",
                filter: "",
                landing_page: "/modules",
                nome_col: "Descrizione",
            },
            isCopy: false,
            item: "",
            key_analisi_generale: 0,
            key_modules: 0,
            key_sub_famiglia: 0,
            key_centro_costo: 0,
            nuova_immagine_presente: false,
            packging: {},
            savebutton: false,
            search: "",
            selectedArticolo: null,
            showadd: true,
            showicon: true,
            showupdate: false,
            sub_famiglia_search: "",
            sub_tipo_search: "",
            tipo_articolo: "",
            tipo_search: "",
            title: "Image Upload",
            topDiv: true,
            validita_search: 1,

            // Modals
            confermaDelArticolo: false,
            conferma_duplica_dialog: false,
            dialog: false,
            dialogAggiungiAllegato: false,
            dialog_analisi_articolo: false,
            dialogAvvisoModificheNonSalvate: false,
            dialog_colori_visible: false,
            dialogModificheDaSalvare: false,
            dialog_modules: false,
            filtro_visible: false,
            gestione_allegati_visible: false,
            loadingVal: false,
            overlay: false,
            pdfdialog: false,
            progressBar: true,
            reportDialog: false,
            selectedPdf: "",

            // Array
            actualItems_backup: [],
            sottoFamList: [],
            centroCostoList: [],
            allegato: [],
            completeData: [],
            contentoreList: [],
            copyInfo: [],
            famiglia_list: [],
            fornitura_list: [],
            header: [],
            headers: [],
            headers2: [
                {
                    align: "",
                    value: "analisi",
                    text: "",
                    sortable: false,
                },
                {
                    align: "",
                    value: "detail",
                    text: "",
                    sortable: false,
                },
                {
                    text: "Cod. Articolo",
                    value: "cod_articolo",
                    sortable: true,
                },
                {
                    text: "Des. articolo",
                    value: "des_articolo",
                    sortable: false,
                },
                {
                    text: "Tipo",
                    value: "id_tipo",
                    sortable: false,
                },
                {
                    text: "Sub Tipo",
                    value: "des_sub_tipo",
                    sortable: false,
                },
                {
                    text: "Famiglia",
                    value: "id_famiglia",
                    sortable: false,
                },
                {
                    text: "Sub famiglia",
                    value: "des_sub_famiglia",
                    sortable: false,
                },
                {
                    text: "Fornitura",
                    value: "id_tipo_fornitura",
                    sortable: false,
                },
                {
                    text: "",
                    value: "delete",
                    sortable: false,
                },
            ],
            imballoList: [],
            items: [],
            items_gestione_lotti: new Array(),
            materiale_list: [],
            mizura_list: [],
            reportHeaders: [
                { text: "Seleziona", value: "select" },
                { text: "Codice", value: "cod_report" },
            ],
            reports: [],
            subtipoList: [],
            swatches: [
                ["#FF0000", "#AA0000", "#550000"],
                ["#FFFF00", "#AAAA00", "#555500"],
                ["#00FF00", "#00AA00", "#005500"],
                ["#00FFFF", "#00AAAA", "#005555"],
                ["#0000FF", "#0000AA", "#000055"],
            ],
            tipoList: [],
            aiDialog: false,
        };
    },
    methods: {
        ClickAI() {
            this.aiDialog = true;
        },
        async DoAISearch() {
            this.overlay = true;
            this.$refs.SnackbarQV.print(
                "orange",
                "Ci potrebbe volere qualche minuto"
            );
            const request = {
                controller: "global",
                method: "POST",
                richiesta: {
                    action: "runaiquery",
                    prompt: this.aiPrompt,
                    token: localStorage.user_token,
                },
            };
            await this.$store
                .dispatch("api6", request)
                .then((res) => {
                    this.aiResult = res.data.result;
                })
                .catch((e) => {
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore: " + e.toString()
                    );
                });
            this.overlay = false;
        },
        closepdf() {
            this.pdfdialog = false;
        },
        apriModules() {
            this.dialog_modules = true;
            this.key_modules = this.key_modules === 0 ? 1 : 0;
        },
        chiudiModules() {
            this.dialog_modules = false;

            // Aggiorno le operazioni all'interno della finestra di dialogo.
            this.aggiornaFornitura();
        },
        selectReport(item) {
            const request = {
                controller: "Allegati",
                method: "PUT",
                richiesta: {
                    action: "stampaeallegasistemavecchio",
                    cod_report: item.cod_report,
                    allegati: [
                        {
                            id_allegato: -1,
                            id_riferimento: this.articolo_sel.id_articolo,
                            des_allegato: "Report",
                            estensione: "PDF",
                            validita: 1,
                            tipo: "ALLEGATI_ARTICOLO",
                            path: "Report.PDF",
                        },
                    ],
                    parametri: [
                        {
                            parametro: "@id_articolo",
                            valore: this.articolo_sel.id_articolo,
                        },
                    ],
                    token: localStorage.user_token,
                },
            };
            this.$store.dispatch("api", request).then(() => {
                this.reportDialog = false;
                this.allegatoKey = !this.allegatoKey;
                this.$refs.SnackbarQV.print(
                    "success",
                    "PDF Generato e Allegato"
                );
            });
        },
        showReportDialog() {
            const request = {
                controller: "Report",
                method: "POST",
                richiesta: {
                    action: "getreportazienda",
                    token: localStorage.user_token,
                },
            };
            this.loading = true;

            this.$store.dispatch("api", request).then((res) => {
                this.reports = res.data;
                this.loading = false;
                this.reportDialog = true;
            });
        },
        chiudiModificaColore() {
            this.dialog_colori_visible = false;
        },
        modificaColore(arg) {
            this.colore_sel = arg;
            this.colore_sfondo_tmp.hex = this.colore_sfondo;
            this.colore_testo_tmp.hex = this.colore_testo;
            this.dialog_colori_visible = true;
        },
        salvaModificaColore() {
            /* Aggiorno il colore del testo o sfondo in base
             * alla selezione con cui ho aperto il dialog. */
            if (this.colore_sel === 1) {
                this.colore_testo = this.colore_testo_tmp.hex;
            } else {
                this.colore_sfondo = this.colore_sfondo_tmp.hex;
            }

            // Chiudo la finestra di dialogo.
            this.dialog_colori_visible = false;
        },
        resetFiltro() {
            // Resetto i filtri
            this.tipo_search = "";
            this.fornitura_search = "";
            this.famiglia_search = "";
            this.sub_tipo_search = "";
            this.sub_famiglia_search = "";

            // Nascondo i filtri
            this.filtro_visible = false;

            // Ricarico la tabella
            this.items = Array.from(this.actualItems_backup);
        },
        showImageViewer() {
            /* Se la mia variabile locale per i dati dell'allegato è
             * già valorizzata, carico questi dati. Se invece non è valorizzata
             * ma sono stato in grado di cliccare sulla miniatura, vuol dire che
             * in passato ho salvato un'immagine e quindi chiedo al BE di mandarmela. */
            if (this.immagine_preview != "") {
                this.$viewerApi({
                    options: {
                        toolbar: true,
                        url: "data-source",
                        initialViewIndex: 0,
                    },
                    images: [{ "data-source": this.immagine_preview }],
                });
            } else {
                const request = {
                    controller: "Global",
                    method: "POST",
                    richiesta: {
                        action: "getallegati",
                        token: localStorage.user_token,
                        id_riferimento: this.articolo_sel.id_articolo,
                        tipo: "ARTICOLO",
                    },
                };
                this.overlay = true;

                this.$store
                    .dispatch("api", request)
                    .then((res) => {
                        this.overlay = false;
                        if (res.status === 200) {
                            const res_tmp =
                                res.data.result.allegati[
                                    res.data.result.allegati.length - 1
                                ];

                            const request2 = {
                                controller: "Global",
                                method: "POST",
                                richiesta: {
                                    action: "getbase64bypath",
                                    token: localStorage.user_token,
                                    path:
                                        localStorage.dbname +
                                        "_ARTICOLO_" +
                                        res_tmp.id_allegato +
                                        "." +
                                        res_tmp.estensione,
                                },
                            };

                            this.overlay = true;
                            this.$store
                                .dispatch("api", request2)
                                .then((res2) => {
                                    this.overlay = false;
                                    if (res2.status === 200) {
                                        this.image_for_viewer =
                                            res2.data.result;

                                        // L'immagine in alta definizione valorizza la mia variabile di supporto
                                        this.$viewerApi({
                                            options: {
                                                toolbar: true,
                                                url: "data-source",
                                                initialViewIndex: 0,
                                            },
                                            images: [
                                                {
                                                    "data-source":
                                                        this.image_for_viewer,
                                                },
                                            ],
                                        });
                                    } else {
                                        this.$refs.SnackbarQV.print(
                                            "orange",
                                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                                        );
                                    }
                                })
                                .catch(() => {
                                    this.overlay = false;
                                    this.$refs.SnackbarQV.print(
                                        "error",
                                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                                    );
                                });
                        }
                    })
                    .catch(() => {
                        this.overlay = false;
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server, impossibile caricare i dati."
                        );
                    });
            }
        },
        filtra() {
            let articoli_tmp = [];
            this.actualItems_backup.forEach((elem) => {
                articoli_tmp.push(elem);
            });

            // Filtro il cod_richiesta
            if (this.tipo_search != "") {
                // Faccio un array temporaneo
                let res = [];

                /* Filtro gli elementi visualizzati dopo i passaggi precedenti
                 * e li inserisco in "res". */
                articoli_tmp.forEach((elem) => {
                    if (elem.id_tipo_R == this.tipo_search) {
                        res.push(elem);
                    }
                });

                // Modello la risposta provvisoria su "res".
                articoli_tmp = res;
            }

            // Filtro il richiedente
            if (this.famiglia_search != "") {
                // Faccio un array temporaneo
                let res = [];

                /* Filtro gli elementi visualizzati dopo i passaggi precedenti
                 * e li inserisco in "res". */
                articoli_tmp.forEach((elem) => {
                    if (elem.id_famiglia_R == this.famiglia_search) {
                        res.push(elem);
                    }
                });

                // Modello la risposta provvisoria su "res".
                articoli_tmp = res;
            }
            if (this.fornitura_search != "") {
                // Faccio un array temporaneo
                let res = [];

                /* Filtro gli elementi visualizzati dopo i passaggi precedenti
                 * e li inserisco in "res". */
                articoli_tmp.forEach((elem) => {
                    if (elem.id_tipo_fornitura == this.fornitura_search) {
                        res.push(elem);
                    }
                });

                // Modello la risposta provvisoria su "res".
                articoli_tmp = res;
            }

            // Filtro la data richiesta

            // Filtro la sede della richiesta
            if (this.sub_tipo_search != "") {
                // Faccio un array temporaneo
                let res = [];

                /* Filtro gli elementi visualizzati dopo i passaggi precedenti
                 * e li inserisco in "res". */
                articoli_tmp.forEach((elem) => {
                    if (elem.id_sub_tipo == this.sub_tipo_search) {
                        res.push(elem);
                    }
                });

                // Modello la risposta provvisoria su "res".\
                articoli_tmp = res;
            }

            // Filtro la struttura della richiesta
            if (this.sub_famiglia_search != "") {
                // Faccio un array temporaneo
                let res = [];

                /* Filtro gli elementi visualizzati dopo i passaggi precedenti
                 * e li inserisco in "res". */
                articoli_tmp.forEach((elem) => {
                    if (elem.id_sub_famiglia == this.sub_famiglia_search) {
                        res.push(elem);
                    }
                });

                // Modello la risposta provvisoria su "res".
                articoli_tmp = res;
            }

            this.items = articoli_tmp;
        },

        // To Resize Image

        resizeImage(img, id) {
            if (img) return;

            if (img.width >= img.height && img.width > 100) {
                let width_nuova = 100;
                // Proporzione -> width_nuova : width = height_nuova : height
                let height_nuova = (width_nuova * img.height) / img.width;

                document.getElementById(id).style.width = width_nuova + "px";
                document.getElementById(id).style.height = height_nuova + "px";
            } else if (img.height > img.width && img.height > 100) {
                let height_nuova = 100;
                // Proporzione -> width_nuova : width = height_nuova : height
                let width_nuova = (height_nuova * img.width) / img.height;
                document.getElementById(id).style.width = width_nuova + "px";
                document.getElementById(id).style.height = height_nuova + "px";
            } else {
                document.getElementById(id).style.width = img.width + "px";
                document.getElementById(id).style.height = img.height + "px";
            }
        },
        // PDF MOdal
        isPdf(elem) {
            if (elem) {
                if (elem.startsWith("data:application/pdf")) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        // to open Modal for PDF
        openPdfAppenaCaricato() {
            if (
                this.articolo_sel.immagine_preview.startsWith(
                    "data:application/pdf"
                )
            ) {
                this.selectedPdf = this.articolo_sel.immagine_preview;
                this.pdfdialog = true;
            }
        },
        // Function to add sub tipo
        aggiornaSubTipoArticolo() {
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "SUB_TIPO_ARTICOLO",
                    filter: `validita = 1`,
                },
            };
            this.$store.dispatch("api", request).then((res) => {
                this.subtipoList = res.data;
            });
        },
        // Function to add Sub Famiglia
        aggiornaSottoFamiglia() {
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "SOTTO_FAMIGLIA",
                    filter: `validita = 1`,
                },
            };
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.sottoFamList = res.data;
                        this.key_sub_famiglia =
                            this.key_sub_famiglia == 0 ? 1 : 0;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore nel caricamento delle sottofamiglie."
                        );
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore nel caricamento delle sottofamiglie."
                    );
                });
        },
        // Function to add Centro Costo
        aggiornaCentroCosto() {
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "CENTRO_COSTO",
                    filter: `validita = 1`,
                },
            };
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.centroCostoList = res.data;
                        this.key_centro_costo =
                            this.key_centro_costo == 0 ? 1 : 0;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore nel caricamento delle sottofamiglie."
                        );
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore nel caricamento delle sottofamiglie."
                    );
                });
        },
        // Function to add new famiglia in famiglia list
        aggiornaFamiglia() {
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "Famiglia",
                    filter: "validita = 1",
                },
            };
            this.$store.dispatch("api", request).then((res) => {
                this.famiglia_list = res.data;
            });
        },
        // Function to add a new fornitura in fornitura list
        aggiornaFornitura() {
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "FORNITURA_STANDARD",
                    filter: "validita = 1",
                },
            };
            this.$store.dispatch("api", request).then((res) => {
                if (res.data) {
                    res.data.forEach((e) => {
                        if (e.val_txt != null && e.val_txt != "") {
                            e.des += ": " + e.val_txt;
                        }
                    });

                    this.fornitura_list = res.data;
                }
            });
        },
        // Function to add a new tipo in tipo list
        aggiornaTipoArticolo() {
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "TIPOARTICOLO",
                    filter: "validita = 1",
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.tipoList = res.data;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server nel recuper dei lotti associati all'articolo."
                        );
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server nel recuper dei lotti associati all'articolo."
                    );
                });
        },
        // in order to close allegati modal
        clearImage() {
            this.dialogAggiungiAllegato = false;
        },
        clickDuplicaArticolo() {
            this.conferma_duplica_dialog = true;
        },
        handleClickChiudiAnalisi() {
            this.dialog_analisi_articolo = false;
        },
        analisiArticolo(item) {
            this.input_args.id_articolo = item.id_articolo;
            this.key_analisi_generale = this.key_analisi_generale == 0 ? 1 : 0;
            this.dialog_analisi_articolo = true;
        },
        // In order to clear all the form fields
        clearFromFields() {
            this.showupdate = false;
            this.showadd = true;
            this.savebutton = true;
            this.showicon = true;
            this.hideField = false;
            this.cod_articolo_enable = true;
            this.cod_articolo_alteration = false;
            this.completeData = [];
            this.articoloDetail = {};
            this.cod_articolo = "";
            this.des_articolo = "";
            this.des_aggiuntiva = "";
            this.dialogModificheDaSalvare = false;
            this.colore_sel = 1;
            this.colore_sfondo = null;
            this.colore_sfondo_tmp = new Object();
            this.colore_testo = null;
            this.colore_testo_tmp = new Object();
        },
        clickGestioneAllegati() {
            this.input_args_allegati.id_riferimento =
                this.articolo_sel.id_articolo;
            this.allegatoKey = !this.allegatoKey;
            this.gestione_allegati_visible = true;
        },
        // In order to disable Codice Articolo
        disabled_Codice(val) {
            if (val !== false) {
                this.cod_articolo_enable = false;
                this.cod_articolo_alteration = true;
            } else {
                this.cod_articolo_alteration = false;
                this.cod_articolo_enable = true;
            }
        },
        duplicaArticolo() {
            let search_Articolo = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "duplicatearticle",
                    token: localStorage.getItem("user_token"),
                    id_articolo: this.articolo_sel.id_articolo,
                    cod_articolo: this.cod_articolo_duplicazione,
                    des_articolo: this.des_articolo_duplicazione,
                    des_aggiuntiva: this.des_aggiuntiva_duplicazione,
                },
            };
            // Attivo l'overlay di caricamento.
            this.overlay = true;
            // Eseguo la chiamata al BE
            this.$store
                .dispatch("api", search_Articolo)
                .then((res) => {
                    this.cod_articolo_duplicazione = "";
                    this.des_articolo_duplicazione = "";
                    this.des_aggiuntiva_duplicazione = "";

                    // Appena ricevo una risposta, blocco l'overlay di caricamento
                    this.overlay = false;

                    // Se la risposta è in stato 200...
                    if (res.status === 200) {
                        this.cod_articolo = res.data[0].cod_articolo;
                        this.searchArticolo();
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            `Una criticità tecnica ha impedito di duplicare l'articolo; codice errore: ${res.status}`
                        );
                    }
                })
                .catch((e) => {
                    this.cod_articolo_duplicazione = "";
                    this.des_articolo_duplicazione = "";
                    this.des_aggiuntiva_duplicazione = "";
                    this.overlay = false;

                    console.error(e.response.data.message);

                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore tecnico nella duplicazione dell'articolo."
                    );
                });
        },
        // Function triggered when search is being triggered in main articolo page
        searchArticolo() {
            this.loadingVal = true;
            this.progressBar = true;
            this.image_for_viewer = "";
            this.items = [];
            let search_Articolo = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getarticoli",
                    token: localStorage.getItem("user_token"),
                    cod_articolo: this.cod_articolo,
                    des_articolo: this.des_articolo,
                    id_famiglia: this.id_famiglia || "",
                    id_tipo: this.id_tipo || "",
                    id_tipo_fornitura: this.id_tipo_fornitura || "",
                    validita: this.validita_search,
                },
            };
            // Attivo l'overlay di caricamento.
            this.overlay = true;
            // Eseguo la chiamata al BE
            this.$store.dispatch("api", search_Articolo).then((res) => {
                this.overlay = false;
                this.actualItems = res.data.lista;
                this.actualItems_backup = res.data.lista;
                if (this.actualItems.length > 0) {
                    this.loadingVal = false;
                    this.progressBar = false;
                }
                if (this.actualItems.length === 0) {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "L'articolo non è stato trovato. Riprova !"
                    );
                    this.loadingVal = false;
                    this.progressBar = false;
                }
                this.items = this.actualItems;
                if (this.items.length > 0) {
                    this.progressBar = false;
                }
                if (this.items.length === 1) {
                    this.cod_articolo_alteration = false;
                    this.cod_articolo_enable = false;
                    this.topDiv = false;
                    this.dialog = false;
                    this.isCopy = true;
                    this.savebutton = true;
                    this.showupdate = true;
                    this.showadd = false;
                    this.hideField = false;
                    this.articolo_sel = new Articolo(
                        JSON.parse(JSON.stringify(res.data.dettaglio[0]))
                    );
                    this.colore_testo = res.data.dettaglio[0].colore_testo;
                    this.colore_sfondo = res.data.dettaglio[0].colore_sfondo;
                    this.id_articolo = res.data.dettaglio[0].id_articolo;
                    this.immagine_preview = this.articolo_sel.immagine_preview;
                    var image = new Image();
                    image.src = this.articolo_sel.immagine_preview;
                    let that = this;
                    image.onload = function () {
                        that.resizeImage(image, "immagine");
                    };
                }
                // Dato che ho avuto la risposta dal BE nascondo l'overlay di caricamento.
                this.overlay = false;
            });
        },
        salvaAllegati() {
            // Salvo gli allegati dell'intervento.
            this.$refs.componenteAllegati.id_riferimento_creazione_genitore =
                this.id_articolo;
            this.$refs.componenteAllegati.salvaTuttiAllegati();

            // Chiudo il dialog degli allegati.
            this.gestione_allegati_visible = false;
        },
        // In order to go back to search articolo lista from detail page
        GobacktoLista() {
            this.articolo_sel = new Articolo();
            this.topDiv = true;
            this.isCopy = false;
            this.dialog = false;
            this.hideField = true;
            this.cod_articolo = "";
            this.des_articolo = "";
            this.des_aggiuntiva = "";
            this.id_tipo = "";
            this.id_tipo_fornitura = "";
            this.id_famiglia = "";
            this.articoloDetail = {};
            this.colore_sel = 1;
            this.colore_sfondo = null;
            this.colore_sfondo_tmp = new Object();
            this.colore_testo = null;
            this.colore_testo_tmp = new Object();
            this.dialogAvvisoModificheNonSalvate = false;
            this.cod_articolo_enable = false;
            this.cod_articolo_alteration = false;
            this.progressBar = true;
        },
        // redirect to articolo main page
        GoBack() {
            // this.showicon = true

            this.dialog = false;
            if (this.copyInfo.length > 0) {
                this.actionItems = this.copyInfo;
            }
            if (this.cod_articolo_alteration) {
                this.dialogAvvisoModificheNonSalvate = true;
            }
            if (!this.cod_articolo_alteration) {
                if (this.items.length > 0) {
                    this.loadingVal = false;
                }
                this.articolo_sel = new Articolo();
                this.topDiv = true;
                this.showupdate = false;
                this.showadd = true;
                this.isCopy = false;
                this.showicon = true;
                this.hideField = true;
                this.cod_articolo = "";
                this.des_articolo = "";
                this.des_aggiuntiva = "";
                this.colore_sel = 1;
                this.colore_sfondo = null;
                this.colore_sfondo_tmp = new Object();
                this.colore_testo = null;
                this.colore_testo_tmp = new Object();
                this.id_tipo = "";
                this.id_tipo_fornitura = "";
                this.id_famiglia = "";
                this.articoloDetail = {};
                this.cod_articolo_enable = false;
                this.cod_articolo_alteration = false;
                this.progressBar = true;
            }
        },
        // TO create a view in order to have an empty form to create a new articolo
        showArticoloForm() {
            // variables needed to show and hide icons in respective view
            this.topDiv = false;
            this.dialog = false;
            this.isCopy = false;
            this.hideField = false;
            this.showicon = false;
            this.showupdate = true;
            this.savebutton = true;
            this.showadd = false;
            //variables needed to lock cod_articolo when form input changes in edit mode
            this.cod_articolo_enable = true;
            this.cod_articolo_alteration = false;
            this.colore_sel = 1;
            this.colore_sfondo = null;
            this.colore_sfondo_tmp = new Object();
            this.colore_testo = null;
            this.colore_testo_tmp = new Object();
            this.id_articolo = "";
            this.articolo_sel.immagine_preview = "";
            this.image_for_viewer = "";
            this.image_for_viewer_name = "";
            this.image_for_viewer_extension = "";
            this.nuova_immagine_presente = false;
            this.immagine_preview = "";
            this.articolo_sel = new Articolo();
        },
        // redirected to production dashboard
        gotoDashboard() {
            if (this.back_as_landing_page === true) {
                this.$router.push(this.rotta_back);
            } else {
                this.$emit("click_chiudi");
            }
        },
        // Function to handle pasted url of image
        onPaste(e) {
            if (e.clipboardData != false) {
                var items = e.clipboardData.items;
                if (items != undefined) {
                    for (var i = 0; i < items.length; i++) {
                        // Skip content if not image
                        if (items[i].type.indexOf("image") == -1) continue;
                        // Retrieve image on clipboard as blob
                        var blob = items[i].getAsFile();
                        console.log(blob);
                    }
                }
            }
            let that = this;
            this.retrieveImageFromClipboardAsBase64(
                e,
                function (imageDataBase64) {
                    that.immagine_preview = imageDataBase64;
                }
            );
        },
        openImagePicker() {
            this.$refs.allegato.click();
        },
        hasExtension(file, exts) {
            return new RegExp(
                "(" + exts.join("|").replace(/\./g, "\\.") + ")$"
            ).test(file.name);
        },
        // Function to select an image and change it to base64
        onFileChange(val) {
            if (
                this.hasExtension(val, [
                    ".gif",
                    ".jpeg",
                    ".JPEG",
                    ".jpg",
                    ".JPG",
                    ".pdf",
                    ".png",
                    ".PNG",
                    ".dxf",
                ])
            ) {
                let that = this;
                let reader = new FileReader();

                reader.onload = function () {
                    /* Solo se si tratta di un'immagine raster, metto a
                     * true il semaforo per sapere che c'è un nuovo allegato.
                     * Se invece l'allegato non è un raster ma un pdf, non ho bisogno
                     * di salvarlo nella cartella degli allegati del BE. */

                    if (that.hasExtension(val, [".pdf"])) {
                        /* Se il file è un PDF lo registro senza comprimerlo e
                         * assegno i debiti valori alle variabili di supporto. */
                        that.immagine_preview = reader.result;
                        that.articolo_sel.immagine_preview =
                            that.immagine_preview;
                        localStorage.setItem(
                            "ArticoloImage",
                            that.immagine_preview
                        );
                        that.image_for_viewer = val.src;
                        that.image_for_viewer_name = val.name;
                        that.image_for_viewer_extension =
                            val.name.split(".")[1];
                    } else {
                        that.nuova_immagine_presente = true;
                        let image = new Image();

                        image.onload = function () {
                            /* Registro l'immagine non compressa e assegno i
                             * debiti valori alle variabili di supporto. */
                            that.image_for_viewer = image.src;
                            that.image_for_viewer_name = val.name;
                            that.image_for_viewer_extension =
                                val.name.split(".")[1];

                            let width, height;
                            let ratio = image.width / image.height;
                            if (image.width > image.height) {
                                width = Math.min(500, image.width);
                                height = width / ratio;
                            } else {
                                height = Math.min(500, image.height);
                                width = height * ratio;
                            }
                            let canvas = document.createElement("canvas");
                            canvas.width = width;
                            canvas.height = height;
                            const ctx = canvas.getContext("2d");
                            ctx.drawImage(image, 0, 0, width, height);

                            that.immagine_preview = ctx.canvas.toDataURL();
                            localStorage.setItem(
                                "ArticoloImage",
                                that.immagine_preview
                            );
                            // that.resizeImage(image, "immagine");
                        };

                        image.src = reader.result;
                    }
                };

                reader.onerror = function (error) {
                    console.error("Error: ", error);
                };

                reader.readAsDataURL(val);
            } else {
                this.dialogAggiungiAllegato = false;
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Formato file non valido."
                );
            }
            this.dialogAggiungiAllegato = false;
        },
        retrieveImageFromClipboardAsBase64(pasteEvent, callback, imageFormat) {
            if (pasteEvent.clipboardData == false) {
                if (typeof callback == "function") {
                    callback(undefined);
                }
            }
            var items = pasteEvent.clipboardData.items;
            if (items == undefined) {
                if (typeof callback == "function") {
                    callback(undefined);
                }
            }
            for (var i = 0; i < items.length; i++) {
                // Skip content if not image
                if (items[i].type.indexOf("image") == -1) continue;
                // Retrieve image on clipboard as blob
                var blob = items[i].getAsFile();
                // Create an abstract canvas and get context
                var mycanvas = document.createElement("canvas");
                var ctx = mycanvas.getContext("2d");
                // Create an image
                var img = new Image();
                // Once the image loads, render the img on the canvas
                img.onload = function () {
                    // Update dimensions of the canvas with the dimensions of the image
                    mycanvas.width = this.width;
                    mycanvas.height = this.height;
                    // Draw the image
                    ctx.drawImage(img, 0, 0);
                    // Execute callback with the base64 URI of the image
                    if (typeof callback == "function") {
                        callback(
                            mycanvas.toDataURL(imageFormat || "image/png")
                        );
                    }
                };
                // Crossbrowser support for URL
                var URLObj = window.URL || window.webkitURL;
                // Creates a DOMString containing a URL representing the object given in the parameter
                // namely the original Blob
                img.src = URLObj.createObjectURL(blob);
            }
            this.dialogAggiungiAllegato = false;
        },
        handleUpdateBarcode(arg) {
            this.articolo_sel.barcode = arg;
        },
        handleUpdateIdReport(arg) {
            this.articolo_sel.id_report = arg;
        },
        handleUpdateScadenza(arg) {
            this.articolo_sel.scadenza = arg;
        },
        handleUpdateUMScadenza(arg) {
            this.articolo_sel.id_um_scadenza = arg;
        },
        handleUpdateCodPrefissoLotto(arg) {
            this.articolo_sel.cod_prefisso_lotto = arg;
        },
        handleUpdatePrefissoLotto(arg) {
            this.articolo_sel.prefisso_lotto = arg;
        },
        handleUpdatePrelievoLottiSuccessivi(arg) {
            this.articolo_sel.prelievo_lotti_successivi = arg;
        },
        // Switching back and forth between main page and detail page
        hideIcons() {
            this.showupdate = true;
            this.showadd = false;
            this.savebutton = true;
            this.showicon = false;
            this.hideField = false;
            this.cod_articolo_enable = true;
            this.cod_articolo_alteration = false;
            this.articolo_sel = new Articolo();
            this.colore_sel = 1;
            this.colore_sfondo = null;
            this.colore_sfondo_tmp = new Object();
            this.colore_testo = null;
            this.colore_testo_tmp = new Object();
        },
        // Changing the view and hiding the corresponding fields or icons
        hideIconS() {
            this.articolo_sel = new Articolo();
            this.showupdate = false;
            this.showadd = true;
            this.savebutton = false;
            this.hideField = true;
            // this.overlay = true;
            this.showicon = true;
            this.cod_articolo_enable = true;
            this.cod_articolo_alteration = false;
            this.immagine_preview = "";
            this.colore_sel = 1;
            this.colore_sfondo = null;
            this.colore_sfondo_tmp = new Object();
            this.colore_testo = null;
            this.colore_testo_tmp = new Object();
        },

        sendVal() {
            this.topDiv = false;
        },
        changeHandler() {
            if (this.cod_articolo.length < 1) {
                this.cod_articolo_alteration = false;
            }
        },
        hideDetail() {
            this.hideField = true;
            this.dialog = false;
            // this.overlay = true;
            this.cod_articolo_alteration = false;
            this.articoloDetail = {};
            this.des_articolo = "";
            this.id_tipo = "";
            this.id_famiglia = "";
            this.id_tipo_fornitura = "";
            this.des_aggiuntiva = "";
            this.colore_sel = 1;
            this.colore_sfondo = null;
            this.colore_sfondo_tmp = new Object();
            this.colore_testo = null;
            this.colore_testo_tmp = new Object();
        },
        updateArticle(val) {
            this.articoloDetail = val;
        },
        updatePackging(val) {
            this.packging = val;
            this.savebutton = true;
        },
        snackbarOpen() {
            //funzione triggerata per cogliere l' errore degli allegati che non hanno la descrizione inserita
            this.$refs.SnackbarQV.print(
                "orange",
                "Aggiungere ad ogni Allegato dell'attività una descrizione."
            );
        },
        // To delete an  articolo
        deleteArticolo(val) {
            this.overlay = true;
            let data = {};
            data.id_articolo = val.id_articolo;
            data.validita = 0;
            let articolo = [data];

            let delArticolo = {
                controller: "Magazzino",
                method: "PUT",
                richiesta: {
                    action: "setarticolo",
                    token: localStorage.getItem("user_token"),
                    articolo: articolo,
                },
            };
            this.$store.dispatch("api", delArticolo).then(() => {
                this.overlay = false;
                this.$refs.SnackbarQV.print(
                    "success",
                    "Modifica effettuata con successo!"
                );
            });
            const i = this.items.findIndex(
                (it) => it.id_articolo === data.id_articolo
            );
            this.items.splice(i, 1);
        },
        // In order to save a new articolo or update an existing articolo
        salvaArticolo(arg_bool) {
            this.overlay = true;
            this.$refs.RefArticoloDrawer.save();
            let search_Articolo = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getarticoli",
                    token: localStorage.getItem("user_token"),
                    cod_articolo: this.articolo_sel.cod_articolo,
                },
            };
            this.overlay = true;
            this.$store
                .dispatch("api", search_Articolo)
                .then(async (res) => {
                    this.overlay = false;

                    if (res.status === 200) {
                        /* Controllo che il codice articolo attuale non sia presente,
                         * o non sia già presente su un altro articolo. */
                        if (
                            res.data.lista.filter(
                                (e) =>
                                    e.cod_articolo ==
                                        this.articolo_sel.cod_articolo &&
                                    e.id_articolo !=
                                        this.articolo_sel.id_articolo
                            ).length > 0
                        ) {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                "Questo codice è già stato associato a un altro articolo."
                            );
                            return;
                        }

                        // Se il mio articolo è nuovo
                        if (this.articolo_sel.id_articolo === -1) {
                            // Controllo di avere un codice articolo
                            if (!this.articolo_sel.cod_articolo) {
                                this.$refs.SnackbarQV.print(
                                    "orange",
                                    "Il campo Codice Articolo è richiesto!"
                                );

                                this.loadingVal = false;
                                this.progressBar = false;
                                return;
                            }

                            // Valorizzo i miei dati
                            let articolo_tmp = new Articolo(this.articolo_sel);
                            articolo_tmp.colore_sfondo = this.colore_sfondo;
                            articolo_tmp.colore_testo = this.colore_testo;
                            articolo_tmp.immagine_preview =
                                localStorage.getItem("ArticoloImage");

                            // To convert cod of id_articolo_contenitore_std,id_articolo_imballo_standard to id_articolo
                            articolo_tmp.id_articolo_contenitore_standard =
                                articolo_tmp.id_articolo_contenitore_standard &&
                                this.contentoreList.filter(
                                    (e) =>
                                        e.cod_articolo ===
                                        articolo_tmp.id_articolo_contenitore_standard
                                ).length > 0
                                    ? this.contentoreList.filter(
                                          (e) =>
                                              e.cod_articolo ===
                                              articolo_tmp.id_articolo_contenitore_standard
                                      )[0].id_articolo
                                    : "";

                            articolo_tmp.id_articolo_imballo_standard =
                                articolo_tmp.id_articolo_imballo_standard &&
                                this.imballoList.filter(
                                    (e) =>
                                        e.cod_articolo ===
                                        articolo_tmp.id_articolo_imballo_standard
                                ).length > 0
                                    ? this.imballoList.filter(
                                          (e) =>
                                              e.cod_articolo ===
                                              articolo_tmp.id_articolo_imballo_standard
                                      )[0].id_articolo
                                    : "";

                            // associating the des of id_tipo to tipo_articolo
                            articolo_tmp.tipo_articolo =
                                articolo_tmp.id_tipo &&
                                this.tipoList.filter(
                                    (e) => articolo_tmp.id_tipo === e.id_tabella
                                ).length > 0
                                    ? this.tipoList.filter(
                                          (e) =>
                                              articolo_tmp.id_tipo ===
                                              e.id_tabella
                                      )[0].des
                                    : "";

                            // associating the des of id_famiglia to famiglia_articolo
                            articolo_tmp.famiglia_articolo =
                                articolo_tmp.id_famiglia &&
                                this.famiglia_list.filter(
                                    (e) =>
                                        articolo_tmp.id_famiglia ===
                                        e.id_tabella
                                ).length > 0
                                    ? this.famiglia_list.filter(
                                          (e) =>
                                              articolo_tmp.id_famiglia ===
                                              e.id_tabella
                                      )[0].des
                                    : "";

                            // associating the des of id_fornitura to fornitura_articolo
                            articolo_tmp.fornitura_articolo =
                                articolo_tmp.id_tipo_fornitura &&
                                this.fornitura_list.filter(
                                    (e) =>
                                        e.id_tabella ===
                                        articolo_tmp.id_tipo_fornitura
                                ).length > 0
                                    ? this.fornitura_list.filter(
                                          (e) =>
                                              e.id_tabella ===
                                              articolo_tmp.id_tipo_fornitura
                                      )[0].des
                                    : "";

                            // associating the des of id_materiale to materiale_articolo
                            articolo_tmp.materiale_articolo =
                                articolo_tmp.id_materiale &&
                                this.materiale_list.filter(
                                    (e) =>
                                        articolo_tmp.id_materiale ===
                                        e.id_tabella
                                ).length > 0
                                    ? this.materiale_list.filter(
                                          (e) =>
                                              articolo_tmp.id_materiale ===
                                              e.id_tabella
                                      )[0].des
                                    : "";

                            // associating the des of id_um to um_articolo
                            articolo_tmp.um_articolo =
                                articolo_tmp.id_um &&
                                this.mizura_list.filter(
                                    (e) => articolo_tmp.id_um === e.id_tabella
                                ).length > 0
                                    ? this.mizura_list.filter(
                                          (e) =>
                                              articolo_tmp.id_um ===
                                              e.id_tabella
                                      )[0].des
                                    : "";

                            // DataToPush is item pushed to local list of articles in creation state
                            let dataToPush = {};
                            dataToPush.cod_articolo = articolo_tmp.cod_articolo;
                            dataToPush.des_articolo = articolo_tmp.des_articolo;
                            dataToPush.id_tipo = articolo_tmp.tipo_articolo;
                            dataToPush.id_famiglia =
                                articolo_tmp.famiglia_articolo;
                            dataToPush.id_tipo_fornitura =
                                articolo_tmp.id_tipo_fornitura;
                            dataToPush.des_sub_tipo = articolo_tmp.des_sub_tipo;
                            dataToPush.des_sub_famiglia =
                                articolo_tmp.des_sub_famiglia;

                            // Salvo i dati sul server.
                            let articolo = [];
                            articolo.push(articolo_tmp);

                            let setArticolo = {
                                controller: "Magazzino",
                                method: "PUT",
                                richiesta: {
                                    action: "setarticolo",
                                    token: localStorage.getItem("user_token"),
                                    articolo: articolo,
                                },
                            };

                            this.overlay = true;

                            await this.$store
                                .dispatch("api", setArticolo)
                                .then((res) => {
                                    this.overlay = false;
                                    if (res.status === 200) {
                                        dataToPush.id_articolo = res.data;
                                        this.items.push(dataToPush);

                                        // Se c'è una nuova immagine da salvare procedo alla logica di salvataggio
                                        if (
                                            this.nuova_immagine_presente ===
                                            true
                                        ) {
                                            const request = {
                                                controller: "Global",
                                                method: "POST",
                                                richiesta: {
                                                    action: "getallegati",
                                                    token: localStorage.user_token,
                                                    id_riferimento: res.data,
                                                    tipo: "ARTICOLO",
                                                },
                                            };

                                            return this.$store
                                                .dispatch("api", request)
                                                .then((res2) => {
                                                    const allegati_tmp = [];
                                                    res2.data.result.allegati.forEach(
                                                        (a) => {
                                                            a.validita = 0;
                                                            allegati_tmp.push(
                                                                Object.assign(a)
                                                            );
                                                        }
                                                    );

                                                    allegati_tmp.push({
                                                        id_allegato: -1,
                                                        id_riferimento:
                                                            res.data,
                                                        tipo: "ARTICOLO",
                                                        path: this
                                                            .image_for_viewer_name,
                                                        des_allegato:
                                                            "Allegato",
                                                        estensione:
                                                            this
                                                                .image_for_viewer_extension,
                                                        validita: 1,
                                                    });
                                                    const setAllegato = {
                                                        controller: "Global",
                                                        method: "PUT",
                                                        richiesta: {
                                                            action: "setallegati",
                                                            token: localStorage.user_token,
                                                            assistenza: "0",
                                                            allegati:
                                                                allegati_tmp,
                                                        },
                                                    };

                                                    return this.$store
                                                        .dispatch(
                                                            "api",
                                                            setAllegato
                                                        )
                                                        .then((res3) => {
                                                            if (
                                                                res3.status ===
                                                                200
                                                            ) {
                                                                // Preparo le variabili di supporto per generare il file dal base64
                                                                const byteString =
                                                                    atob(
                                                                        this.image_for_viewer.split(
                                                                            ","
                                                                        )[1]
                                                                    );
                                                                const mimeString =
                                                                    this.image_for_viewer
                                                                        .split(
                                                                            ","
                                                                        )[0]
                                                                        .split(
                                                                            ":"
                                                                        )[1]
                                                                        .split(
                                                                            ";"
                                                                        )[0];
                                                                const ab =
                                                                    new ArrayBuffer(
                                                                        byteString.length
                                                                    );
                                                                const ia =
                                                                    new Uint8Array(
                                                                        ab
                                                                    );
                                                                for (
                                                                    let i = 0;
                                                                    i <
                                                                    byteString.length;
                                                                    i += 1
                                                                ) {
                                                                    ia[i] =
                                                                        byteString.charCodeAt(
                                                                            i
                                                                        );
                                                                }
                                                                let blob =
                                                                    new Blob(
                                                                        [ab],
                                                                        {
                                                                            type: mimeString,
                                                                        }
                                                                    );
                                                                blob.name =
                                                                    "cattura." +
                                                                    this
                                                                        .image_for_viewer_extension;
                                                                blob.lastModified =
                                                                    moment().valueOf();

                                                                /* Salvo i dati dell'allegato collegandoli al
                                                                 * riferimento che il BE mi ha resittuito. */
                                                                let form_data =
                                                                    new FormData();
                                                                form_data.append(
                                                                    localStorage.dbname +
                                                                        "_" +
                                                                        "ARTICOLO_" +
                                                                        res3
                                                                            .data[
                                                                            res3
                                                                                .data
                                                                                .length -
                                                                                1
                                                                        ]
                                                                            .id_allegato +
                                                                        "." +
                                                                        this
                                                                            .image_for_viewer_extension,
                                                                    blob
                                                                );
                                                                return new Promise(
                                                                    (
                                                                        resolve,
                                                                        reject
                                                                    ) => {
                                                                        axios
                                                                            .post(
                                                                                this
                                                                                    .$store
                                                                                    .state
                                                                                    .config
                                                                                    .ip +
                                                                                    "api/Allegato/inserisci",
                                                                                form_data,
                                                                                {
                                                                                    headers:
                                                                                        {
                                                                                            Token: localStorage.user_token,
                                                                                        },
                                                                                }
                                                                            )
                                                                            .then(
                                                                                (
                                                                                    result
                                                                                ) => {
                                                                                    this.overlay = false;
                                                                                    if (
                                                                                        result.data
                                                                                    ) {
                                                                                        this.$refs.SnackbarQV.print(
                                                                                            "orange",
                                                                                            "Modifica effettuata con successo!"
                                                                                        );

                                                                                        // Se devo salvare e continuare, ricarico l'articolo appena salvato
                                                                                        if (
                                                                                            arg_bool ===
                                                                                            true
                                                                                        ) {
                                                                                            /* Resetto i filtri della searchArticolo
                                                                                             * altrimenti la searchArticolo si rompe. */
                                                                                            this.id_tipo =
                                                                                                "";
                                                                                            this.id_famiglia =
                                                                                                "";
                                                                                            this.id_tipo_fornitura =
                                                                                                "";

                                                                                            // Eseguo la searchArticolo
                                                                                            this.searchArticolo();
                                                                                        }
                                                                                    }

                                                                                    resolve(
                                                                                        result
                                                                                    );
                                                                                    return true;
                                                                                }
                                                                            )
                                                                            .catch(
                                                                                (
                                                                                    err
                                                                                ) => {
                                                                                    reject(
                                                                                        err
                                                                                    );
                                                                                    return false;
                                                                                }
                                                                            );
                                                                    }
                                                                );
                                                            } else {
                                                                this.$refs.SnackbarQV.print(
                                                                    "orange",
                                                                    "Errore di comunicazione col server, non è stato possibile salvare i dati."
                                                                );
                                                                return false;
                                                            }
                                                        })
                                                        .catch((e) => {
                                                            console.error(e);
                                                            this.$refs.SnackbarQV.print(
                                                                "error",
                                                                "Errore di comunicazione col server, non è stato possibile salvare i dati."
                                                            );
                                                            return false;
                                                        });
                                                });
                                        } else {
                                            // Se non ho aggiunto un allegato all'articolo...

                                            // Se devo salvare e continuare, ricarico l'articolo appena salvato
                                            if (arg_bool === true) {
                                                /* Resetto i filtri della searchArticolo
                                                 * altrimenti la searchArticolo si rompe. */
                                                this.id_tipo = "";
                                                this.id_famiglia = "";
                                                this.id_tipo_fornitura = "";

                                                // Eseguo la searchArticolo
                                                this.cod_articolo =
                                                    articolo_tmp.cod_articolo;
                                                this.searchArticolo();
                                            }

                                            this.overlay = false;
                                            if (res.data) {
                                                this.$refs.SnackbarQV.print(
                                                    "success",
                                                    "Modifica effettuata con successo!"
                                                );
                                            }
                                        }
                                    }
                                });

                            // Se devo salvare e tornare alla videata dei consuntivi...
                            if (arg_bool === false) {
                                this.articolo_sel.immagine_preview = "";
                                localStorage.removeItem("ArticoloImage");
                                this.image_for_viewer = "";
                                this.image_for_viewer_name = "";
                                this.image_for_viewer_extension = "";
                                this.nuova_immagine_presente = false;
                                this.cod_articolo_enable = false;
                                this.cod_articolo_alteration = false;
                                this.hideIconS();
                                this.topDiv = true;
                                this.cod_articolo = "";
                            }
                        }

                        // Se invece il mio articolo non è nuovo...
                        if (this.articolo_sel.id_articolo > -1) {
                            this.articoloDetail = this.articolo_sel;
                            this.articoloDetail.colore_sfondo =
                                this.colore_sfondo;
                            this.articoloDetail.colore_testo =
                                this.colore_testo;
                            this.articoloDetail.immagine_preview =
                                this.immagine_preview;
                            this.articoloDetail.validita = 1;
                            this.articoloDetail.tipo_articolo =
                                this.tipoList.filter(
                                    (e) =>
                                        this.articoloDetail.id_tipo ===
                                        e.id_tabella
                                ).length > 0
                                    ? this.tipoList.filter(
                                          (e) =>
                                              this.articoloDetail.id_tipo ===
                                              e.id_tabella
                                      )[0].des
                                    : "";

                            this.articoloDetail.famiglia_articolo =
                                this.famiglia_list.filter(
                                    (e) =>
                                        this.articoloDetail.id_famiglia ===
                                        e.id_tabella
                                ).length > 0
                                    ? this.famiglia_list.filter(
                                          (e) =>
                                              this.articoloDetail
                                                  .id_famiglia === e.id_tabella
                                      )[0].des
                                    : "";

                            this.articoloDetail.fornitura_articolo =
                                this.fornitura_list.filter(
                                    (e) => this.id_tipo_fornitura === e.des
                                ).length > 0
                                    ? this.fornitura_list.filter(
                                          (e) =>
                                              this.id_tipo_fornitura === e.des
                                      )[0].des
                                    : "";

                            this.articoloDetail.materiale_articolo =
                                this.materiale_list.filter(
                                    (e) =>
                                        this.articoloDetail.id_materiale ===
                                        e.id_tabella
                                ).length > 0
                                    ? this.materiale_list.filter(
                                          (e) =>
                                              this.articoloDetail
                                                  .id_materiale === e.id_tabella
                                      )[0].des
                                    : "";

                            this.articoloDetail.um_articolo =
                                this.mizura_list.filter(
                                    (e) =>
                                        this.articoloDetail.id_um ===
                                        e.id_tabella
                                ).length > 0
                                    ? this.mizura_list.filter(
                                          (e) =>
                                              this.articoloDetail.id_um ===
                                              e.id_tabella
                                      )[0].des
                                    : "";

                            // Se sono stati aperti i costi, li salvo.
                            if (
                                this.$refs.RefArticoloDrawer.$refs.articoloCosto
                            ) {
                                this.articoloDetail.costo_imballo =
                                    this.$refs.RefArticoloDrawer.$refs.articoloCosto.costo_imballo;
                                this.articoloDetail.costo_standard =
                                    this.$refs.RefArticoloDrawer.$refs.articoloCosto.costo_standard;
                                this.articoloDetail.costo_trasporto =
                                    this.$refs.RefArticoloDrawer.$refs.articoloCosto.costo_trasporto;
                                this.articoloDetail.tipo_costo =
                                    this.$refs.RefArticoloDrawer.$refs.articoloCosto.tipo_costo;
                                this.articoloDetail.prezzo_standard =
                                    this.$refs.RefArticoloDrawer.$refs.articoloCosto.prezzo_standard;
                            } else {
                                console.log(
                                    "no articolo costi",
                                    this.$refs.RefArticoloDrawer
                                );
                            }

                            // Procedo a salvare i dati del mio articolo...
                            let articolo = [];
                            articolo.push(this.articoloDetail);

                            let setArticolo = {
                                controller: "Magazzino",
                                method: "PUT",
                                richiesta: {
                                    action: "setarticolo",
                                    articolo: articolo,
                                    token: localStorage.getItem("user_token"),
                                },
                            };

                            this.$store
                                .dispatch("api", setArticolo)
                                .then((res) => {
                                    this.overlay = false;
                                    if (res.status === 200) {
                                        this.$refs.SnackbarQV.print(
                                            "success",
                                            "Modifica effettuata con successo!"
                                        );

                                        if (this.items.length > 0) {
                                            const data = {};
                                            data.id_articolo =
                                                this.articoloDetail.id_articolo;
                                            data.cod_articolo =
                                                this.articoloDetail.cod_articolo;
                                            data.des_articolo =
                                                this.articoloDetail.des_articolo;
                                            this.tipoList.map((it) => {
                                                if (
                                                    it.id_tabella ===
                                                    this.articoloDetail.id_tipo
                                                ) {
                                                    data.id_tipo = it.des;
                                                    data.tipo_articolo = it.des;
                                                }
                                            });
                                            this.famiglia_list.map((it) => {
                                                if (
                                                    it.id_tabella ===
                                                    this.articoloDetail
                                                        .id_famiglia
                                                ) {
                                                    data.id_famiglia = it.des;
                                                    data.famiglia_articolo =
                                                        it.des;
                                                }
                                            });
                                            this.fornitura_list.map((it) => {
                                                if (
                                                    it.id_tabella ===
                                                    this.articoloDetail
                                                        .id_tipo_fornitura
                                                ) {
                                                    data.id_tipo_fornitura =
                                                        it.des;
                                                    data.fornitura_articolo =
                                                        it.des;
                                                }
                                            });
                                            this.sottoFamList.forEach(
                                                (elem) => {
                                                    if (
                                                        elem.id_tabella ===
                                                        this.articoloDetail
                                                            .id_sub_famiglia
                                                    ) {
                                                        data.des_sub_famiglia =
                                                            elem.des;
                                                    }
                                                }
                                            );
                                            this.subtipoList.forEach((elem) => {
                                                if (
                                                    elem.id_tabella ===
                                                    this.id_sub_tipo
                                                ) {
                                                    data.des_sub_tipo =
                                                        elem.des;
                                                }
                                            });
                                            const i = this.items.findIndex(
                                                (it) =>
                                                    it.cod_articolo ===
                                                    this.articoloDetail
                                                        .cod_articolo
                                            );

                                            if (
                                                this.nuova_immagine_presente ===
                                                true
                                            ) {
                                                /* Se ho un allegato da salvare in coda,
                                                 * lo salvo e faccio le chiamate necessarie. */
                                                const request = {
                                                    controller: "Global",
                                                    method: "POST",
                                                    richiesta: {
                                                        action: "getallegati",
                                                        token: localStorage.user_token,
                                                        id_riferimento:
                                                            this.articolo_sel
                                                                .id_articolo,
                                                        tipo: "ARTICOLO",
                                                    },
                                                };
                                                this.overlay = true;

                                                this.$store
                                                    .dispatch("api", request)
                                                    .then((res2) => {
                                                        this.overlay = false;
                                                        const allegati_tmp = [];
                                                        res2.data.result.allegati.forEach(
                                                            (a) => {
                                                                a.validita = 0;
                                                                allegati_tmp.push(
                                                                    Object.assign(
                                                                        a
                                                                    )
                                                                );
                                                            }
                                                        );

                                                        allegati_tmp.push({
                                                            id_allegato: -1,
                                                            id_riferimento:
                                                                res.data,
                                                            tipo: "ARTICOLO",
                                                            path: this
                                                                .image_for_viewer_name,
                                                            des_allegato:
                                                                "Allegato",
                                                            estensione:
                                                                this
                                                                    .image_for_viewer_extension,
                                                            validita: 1,
                                                        });
                                                        const setAllegato = {
                                                            controller:
                                                                "Global",
                                                            method: "PUT",
                                                            richiesta: {
                                                                action: "setallegati",
                                                                token: localStorage.user_token,
                                                                assistenza: "0",
                                                                allegati:
                                                                    allegati_tmp,
                                                            },
                                                        };

                                                        this.overlay = true;
                                                        this.$store
                                                            .dispatch(
                                                                "api",
                                                                setAllegato
                                                            )
                                                            .then((res3) => {
                                                                this.overlay = false;
                                                                // Preparo le variabili di supporto per generare il file dal base64
                                                                const byteString =
                                                                    atob(
                                                                        this.image_for_viewer.split(
                                                                            ","
                                                                        )[1]
                                                                    );
                                                                const mimeString =
                                                                    this.image_for_viewer
                                                                        .split(
                                                                            ","
                                                                        )[0]
                                                                        .split(
                                                                            ":"
                                                                        )[1]
                                                                        .split(
                                                                            ";"
                                                                        )[0];
                                                                const ab =
                                                                    new ArrayBuffer(
                                                                        byteString.length
                                                                    );
                                                                const ia =
                                                                    new Uint8Array(
                                                                        ab
                                                                    );
                                                                for (
                                                                    let i = 0;
                                                                    i <
                                                                    byteString.length;
                                                                    i += 1
                                                                ) {
                                                                    ia[i] =
                                                                        byteString.charCodeAt(
                                                                            i
                                                                        );
                                                                }
                                                                let blob =
                                                                    new Blob(
                                                                        [ab],
                                                                        {
                                                                            type: mimeString,
                                                                        }
                                                                    );
                                                                blob.name =
                                                                    "cattura." +
                                                                    this
                                                                        .image_for_viewer_extension;
                                                                blob.lastModified =
                                                                    moment().valueOf();

                                                                /* Salvo i dati dell'allegato usando il
                                                                 * riferimento che mi è stato passato dal BE. */
                                                                if (
                                                                    res3.status ===
                                                                    200
                                                                ) {
                                                                    let form_data =
                                                                        new FormData();
                                                                    form_data.append(
                                                                        localStorage.dbname +
                                                                            "_" +
                                                                            "ARTICOLO_" +
                                                                            res3
                                                                                .data[
                                                                                res3
                                                                                    .data
                                                                                    .length -
                                                                                    1
                                                                            ]
                                                                                .id_allegato +
                                                                            "." +
                                                                            this
                                                                                .image_for_viewer_extension,
                                                                        blob
                                                                    );
                                                                    this.overlay = true;

                                                                    new Promise(
                                                                        (
                                                                            resolve,
                                                                            reject
                                                                        ) => {
                                                                            axios
                                                                                .post(
                                                                                    this
                                                                                        .$store
                                                                                        .state
                                                                                        .config
                                                                                        .ip +
                                                                                        "api/Allegato/inserisci",
                                                                                    form_data,
                                                                                    {
                                                                                        headers:
                                                                                            {
                                                                                                Token: localStorage.user_token,
                                                                                            },
                                                                                    }
                                                                                )
                                                                                .then(
                                                                                    (
                                                                                        result
                                                                                    ) => {
                                                                                        this.overlay = false;
                                                                                        if (
                                                                                            result.status ===
                                                                                            200
                                                                                        ) {
                                                                                            // Se devo salvare e tornare alla videata dei consuntivi...
                                                                                            if (
                                                                                                arg_bool ===
                                                                                                true
                                                                                            ) {
                                                                                                /* Resetto i filtri della searchArticolo
                                                                                                 * altrimenti la searchArticolo si rompe. */
                                                                                                this.id_tipo =
                                                                                                    "";
                                                                                                this.id_famiglia =
                                                                                                    "";
                                                                                                this.id_tipo_fornitura =
                                                                                                    "";

                                                                                                // Eseguo la searchArticolo
                                                                                                this.searchArticolo();
                                                                                            } else {
                                                                                                this.$set(
                                                                                                    this
                                                                                                        .items,
                                                                                                    i,
                                                                                                    data
                                                                                                );
                                                                                                this.hideIconS();
                                                                                                this.topDiv =
                                                                                                    arg_bool ===
                                                                                                    true
                                                                                                        ? false
                                                                                                        : true;
                                                                                                this.cod_articolo_enable = true;
                                                                                                this.cod_articolo_alteration = false;
                                                                                                localStorage.removeItem(
                                                                                                    "ArticoloImage"
                                                                                                );
                                                                                                this.articolo_sel.immagine_preview =
                                                                                                    "";
                                                                                                this.image_for_viewer =
                                                                                                    "";
                                                                                                this.image_for_viewer_name =
                                                                                                    "";
                                                                                                this.image_for_viewer_extension =
                                                                                                    "";
                                                                                            }
                                                                                        } else {
                                                                                            this.$refs.SnackbarQV.print(
                                                                                                "orange",
                                                                                                "Errore di comunicazione col server, non è stato possibile salvare i dati."
                                                                                            );
                                                                                        }

                                                                                        resolve(
                                                                                            result
                                                                                        );
                                                                                    }
                                                                                )
                                                                                .catch(
                                                                                    (
                                                                                        err
                                                                                    ) => {
                                                                                        reject(
                                                                                            err
                                                                                        );
                                                                                    }
                                                                                );
                                                                        }
                                                                    );
                                                                }
                                                            });
                                                    });
                                            } else {
                                                // Se devo salvare e tornare alla videata dei consuntivi...
                                                if (arg_bool === false) {
                                                    this.$set(
                                                        this.items,
                                                        i,
                                                        data
                                                    );
                                                    this.hideIconS();
                                                    this.topDiv =
                                                        arg_bool === true
                                                            ? false
                                                            : true;
                                                    this.cod_articolo_enable = true;
                                                    this.cod_articolo_alteration = false;
                                                    localStorage.removeItem(
                                                        "ArticoloImage"
                                                    );
                                                    this.articolo_sel.immagine_preview =
                                                        "";
                                                    this.image_for_viewer = "";
                                                    this.image_for_viewer_name =
                                                        "";
                                                    this.image_for_viewer_extension =
                                                        "";
                                                    this.nuova_immagine_presente = false;
                                                }
                                            }
                                        }
                                    }
                                });
                        }
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, impossibile caricare i dati."
                        );
                        this.overlay = false;
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.overlay = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile salvare i dati."
                    );
                });
        },
        // Search Function triggered within the detail page
        searchResult() {
            let tmp_id = this.articolo_sel.cod_articolo;
            this.articolo_sel = new Articolo();
            this.cod_articolo_alteration = false;
            this.cod_articolo_enable = true;
            this.colore_sel = 1;
            this.colore_sfondo = null;
            this.colore_sfondo_tmp = new Object();
            this.colore_testo = null;
            this.colore_testo_tmp = new Object();
            this.image_for_viewer = "";
            // this.loadingVal = true
            if (this.articolo_sel.cod_articolo === "") {
                return;
            }

            let search_Arti_req2 = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getarticoli",
                    token: localStorage.getItem("user_token"),
                    cod_articolo: tmp_id,
                    id_famiglia:
                        this.id_famiglia.id_tabella == undefined
                            ? ""
                            : this.id_famiglia.id_tabella,
                    id_tipo:
                        this.id_tipo.id_tabella == undefined
                            ? ""
                            : this.id_tipo.id_tabella,
                    id_tipo_fornitura:
                        this.id_tipo_fornitura == undefined
                            ? ""
                            : this.id_tipo_fornitura,
                },
            };
            // Attivo l'overlay di caricamento
            this.overlay = true;
            // Eseguo la chiamata al BE
            this.$store.dispatch("api", search_Arti_req2).then((res) => {
                this.completeData = res.data;
                if (this.completeData.lista.length > 1) {
                    if (!this.topDiv) {
                        this.topDiv = false;
                    } else {
                        this.topDiv = true;
                    }
                    this.savebutton = false;
                    this.dialog = true;
                }
                if (this.completeData.lista.length === 0) {
                    this.$refs.SnackbarQV.print(
                        "error",
                        "L'articolo non è stato trovato. Riprova!"
                    );

                    this.loadingVal = false;
                    this.progressBar = false;
                    this.savebutton = false;
                    this.topDiv = true;
                }
                if (res.data.lista.length === 1) {
                    this.overlay = false;
                    // this.cod_articolo_alteration = false;
                    // this.cod_articolo_enable = true;
                    this.isCopy = true;
                    this.topDiv = false;
                    this.dialog = false;
                    this.savebutton = true;
                    this.showupdate = true;
                    this.showadd = false;
                    this.colore_sfondo =
                        this.completeData.dettaglio[0].colore_sfondo;
                    this.colore_testo =
                        this.completeData.dettaglio[0].colore_testo;
                    this.articolo_sel = new Articolo(
                        JSON.parse(
                            JSON.stringify(this.completeData.dettaglio[0])
                        )
                    );
                    this.hideField = false;
                    this.immagine_preview = this.articolo_sel.immagine_preview;
                    let that = this;
                    var image = new Image();
                    image.src = this.immagine_preview;
                    image.onload = function () {
                        that.resizeImage(image, "immagine");
                    };
                    this.savebutton = true;
                    this.codArticolo = this.cod_articolo;
                }
                // Disattivo l'overlay di caricamento
                this.overlay = false;
            });
        },
        //In order to get detail of single articolo when button is clicked
        onButtonClick(value) {
            this.image_for_viewer = "";
            this.cod_articolo_enable = false;
            this.articolo_sel = new Articolo();
            this.overlay = true;
            let search_Arti_req = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getarticoli",
                    token: localStorage.getItem("user_token"),
                    // cod_articolo: value.cod_articolo,
                    id_articolo: value.id_articolo,
                    id_famiglia: (this.id_famiglia = ""),
                    id_tipo: (this.id_tipo = ""),
                    validita: this.validita_search,
                },
            };
            this.$store
                .dispatch("api", search_Arti_req)
                .then((res) => {
                    this.overlay = false;
                    if (!res.data.articolo[0]) {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Non sono stati trovati dati per questo articolo."
                        );
                        return;
                    }

                    this.completeData = res.data.articolo;
                    if (this.completeData.length > 1) {
                        this.topDiv = true;
                        this.savebutton = false;
                    }
                    if (this.completeData.length === 0) {
                        this.topDiv = true;
                        this.savebutton = false;
                    }
                    if (this.completeData.length == 1) {
                        // this.cod_articolo_alteration = false;
                        this.cod_articolo_enable = true;
                        this.topDiv = false;
                        this.dialog = false;
                        this.savebutton = true;
                        this.showupdate = true;
                        this.showadd = false;
                        this.isCopy = true;
                        this.hideField = false;
                        this.colore_sfondo = this.completeData[0].colore_sfondo;
                        this.colore_testo = this.completeData[0].colore_testo;
                        this.articolo_sel = new Articolo(this.completeData[0]);
                        this.immagine_preview =
                            this.articolo_sel.immagine_preview;
                        this.hideField = false;
                        let that = this;
                        var image = new Image();
                        image.src = this.articolo_sel.immagine_preview;
                        this.id_articolo = that.id_articolo;
                        image.onload = function () {
                            that.resizeImage(image, "immagine");
                        };
                    }

                    this.dialog = false;
                })
                .catch((err) => {
                    console.error(err);
                    this.overlay = false;
                });
        },
        // Search Function triggered in Articolo Detail
        searchResult1(val) {
            let search_Arti_req = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getarticoli",
                    token: localStorage.getItem("user_token"),
                    cod_articolo: val.cod_articolo,
                    id_famiglia:
                        val.id_famiglia.id_tabella == undefined
                            ? ""
                            : this.id_famiglia.id_tabella,
                    id_tipo:
                        val.id_tipo.id_tabella == undefined
                            ? ""
                            : this.id_tipo.id_tabella,
                },
            };
            this.$store.dispatch("api", search_Arti_req).then((res) => {
                this.completeData = res.data;
                if (this.completeData.lista.length > 1) {
                    // this.overlay = false;
                    this.topDiv = true;
                    this.dialog = true;
                }
                if (this.completeData.lista.length === 0) {
                    this.snackbar = true;
                    this.dialog = false;
                }
                this.articolo_sel = new Articolo(
                    JSON.parse(JSON.stringify(this.completeData.dettaglio[0]))
                );
                this.overlay = false;
                this.isCopy = true;

                this.immagine_preview =
                    this.completeData.dettaglio[0].immagine_preview;
                this.colore_sfondo =
                    this.completeData.dettaglio[0].colore_sfondo;
                this.colore_testo = this.completeData.dettaglio[0].colore_testo;
                let that = this;
                var image = new Image();
                image.src = this.immagine_preview;
                image.onload = function () {
                    that.resizeImage(image, "immagine");
                };

                this.hideField = false;
            });
        },
        syncArticoli() {
            /* Eseguo una chiamata al BE, che in base al DB loggato
             * sa se deve aggiornare la lista degli articoli confrontandola
             * con le anagrafiche raccolte in un servizio esterno.
             * Questa procedura avviene per Sicily Food. Sia che sia
             * e necessaria o meno questa operazione, il BE dovrebbe
             * rispondere con un 200. */
            const request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "sync",
                    action2: "articolo",
                    token: localStorage.user_token,
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        return;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non  stato possibile salvare i dati."
                        );
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non  stato possibile salvare i dati."
                    );
                });
        },
    },
    watch: {
        "articolo_sel.id_articolo": function (val, oldVal) {
            if (oldVal != val) {
                this.cod_articolo_alteration = false;
                this.cod_articolo_enable = true;
            }
        },
        "articolo_sel.cod_articolo": function (val, oldVal) {
            if (
                oldVal == "" ||
                val === "" ||
                (oldVal !== val &&
                    oldVal == null &&
                    this.articolo_sel.id_articolo > -1)
            ) {
                this.cod_articolo_alteration = false;
                this.cod_articolo_enable = true;
            }
        },
        immagine_preview: function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (val !== oldVal && this.articolo_sel.id_articolo > -1) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.des_articolo": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                    this.cod_articolo_enable = false;
                }
            }
        },
        "articolo_sel.id_tipo": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.id_famiglia": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.des_aggiuntiva": function (val, oldVal) {
            if (this.cod_articolo_enable && oldVal != "") {
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.id_tipo_fornitura": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.id_um": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.vendita_kit": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.l": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.p": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.h": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.id_um_fisica": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.peso_netto": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.peso_lordo": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },

        "articolo_sel.peso_specifico": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.id_um_peso": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },

        "articolo_sel.id_materiale": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.volume": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.diametro": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.id_um_volume": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.ricezione_peso_netto": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.ricezione_peso_lordo": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
        "articolo_sel.note": function (val, oldVal) {
            if (this.cod_articolo_enable) {
                if (!oldVal) {
                    this.cod_articolo_alteration = false;
                }
                if (
                    val !== oldVal &&
                    oldVal &&
                    this.articolo_sel.id_articolo > -1
                ) {
                    this.cod_articolo_alteration = true;
                }
            }
        },
    },
    computed: {
        disabled() {
            return this.cod_articolo < 1 && this.des_articolo < 1;
        },
        disabledes() {
            return this.hideField;
        },
        disabletipo() {
            return this.hideField;
        },
        disableFam() {
            return this.hideField;
        },
        disableForn() {
            return this.hideField;
        },
        disableAggun() {
            return this.hideField;
        },
    },
    mounted() {
        /* I emit an event for the sake of correct loading process,
         * when the component is called in an external dynamic form.  */
        this.$emit("whoIsMyFather", {
            customHandler: (arg) => {
                this.onButtonClick(arg[0]);
            },
        });

        this.syncArticoli();

        // In order to table headers
        let listaArticoli = {
            controller: "Magazzino",
            method: "POST",
            richiesta: {
                action: "getheader",
                nome_modulo: "lista_articoli",
                token: localStorage.getItem("user_token"),
            },
        };
        let dataarray = [];
        this.$store.dispatch("api", listaArticoli).then((res) => {
            dataarray = res.data;
            dataarray.map((el) => {
                this.header.push({
                    text: el.text,
                    value: el.value,
                });
            });
            this.header.splice(0, 0, {
                text: "dettaglio",
                value: "actions",
            });
        });
        // In order to get all the lists for select fields
        let fam_list = {
            controller: "Magazzino",
            method: "POST",
            richiesta: {
                action: "gettabelle",
                token: localStorage.getItem("user_token"),
                tipo: "'FAMIGLIA','TIPOARTICOLO','FORNITURA_STANDARD','SUB_TIPO_ARTICOLO','SOTTO_FAMIGLIA', 'CENTRO_COSTO'",
                filter: "validita = 1",
            },
        };
        this.$store
            .dispatch("api", fam_list)
            .then((res) => {
                if (res.status === 200) {
                    this.famiglia_list =
                        res.data.FAMIGLIA != undefined ? res.data.FAMIGLIA : [];

                    this.fornitura_list = new Array();
                    if (res.data.FORNITURA_STANDARD) {
                        res.data.FORNITURA_STANDARD.forEach((e) => {
                            if (e.val_txt != null && e.val_txt != "") {
                                e.des += ": " + e.val_txt;
                            }
                        });

                        this.fornitura_list = res.data.FORNITURA_STANDARD;
                    }

                    this.tipoList =
                        res.data.TIPOARTICOLO != undefined
                            ? res.data.TIPOARTICOLO
                            : [];
                    this.subtipoList =
                        res.data.SUB_TIPO_ARTICOLO != undefined
                            ? res.data.SUB_TIPO_ARTICOLO
                            : [];
                    this.sottoFamList =
                        res.data.SOTTO_FAMIGLIA != undefined
                            ? res.data.SOTTO_FAMIGLIA
                            : [];
                    this.centroCostoList =
                        res.data.CENTRO_COSTO != undefined
                            ? res.data.CENTRO_COSTO
                            : [];
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server."
                    );
                }
            })
            .catch((err) => {
                console.error(err);
                this.$refs.SnackbarQV.print(
                    "error",
                    "Errore di comunicazione col server."
                );
            });

        // if the articoloId is passed from external comp. article will open in detail view
        if (this.articoloId) {
            this.disableAppBar = false;
            let search_recursive = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getarticoli",
                    token: localStorage.getItem("user_token"),
                    id_articolo: this.articoloId,
                    id_famiglia:
                        this.id_famiglia.id_tabella == undefined
                            ? ""
                            : this.id_famiglia.id_tabella,
                    id_tipo:
                        this.id_tipo.id_tabella == undefined
                            ? ""
                            : this.id_tipo.id_tabella,
                },
            };
            this.$store.dispatch("api", search_recursive).then((res) => {
                this.completeData = res.data;
                this.topDiv = false;
                this.dialog = false;
                this.articoloDetail = JSON.parse(
                    JSON.stringify(this.completeData.articolo[0])
                );
                this.hideField = false;
                // this.overlay = false
                this.des_articolo = this.articoloDetail.des_articolo;
                this.id_tipo_fornitura = this.articoloDetail.id_tipo_fornitura;
                this.id_tipo1 = this.articoloDetail.id_tipo;
                this.id_famiglia1 = this.articoloDetail.id_famiglia;
                this.des_aggiuntiva = this.articoloDetail.des_aggiuntiva;
                this.colore_sfondo = this.articoloDetail.colore_sfondo;
                this.colore_testo = this.articoloDetail.colore_testo;
                this.cod_articolo = this.articoloDetail.cod_articolo;
                this.id_articolo = this.articoloDetail.id_articolo
                    ? this.articoloDetail.id_articolo
                    : "";
                this.articolo_sel.immagine_preview =
                    this.articoloDetail.immagine_preview;
                let that = this;
                var image = new Image();
                image.src = this.articolo_sel.immagine_preview;
                image.onload = function () {
                    that.resizeImage(image, "immagine");
                };
                this.savebutton = true;
            });
        }

        /* This is needed only in case Articolo is landed
         * after hitting a specific button from the component
         * FamiglieArticolo.vue of Electrical Marine: then I need
         * to make a search and filter for a specific Famiglia
         * which has been chosen in the previous module. */
        if (this.$store.state.id_famiglia_articolo) {
            this.cod_articolo = "*";
            this.id_famiglia = this.$store.state.id_famiglia_articolo;
            delete this.$store.state.id_famiglia_articolo;
            this.searchArticolo();
        }
    },
};
</script>
<style lang="scss"></style>
